/* PRUÉBALO EN TU SALÓN — el flujo. Cuadros Splash (24 sep 2026).

   Tres pasos, y todo lo demás es para que se sientan como uno:

     1. PORTADA   — subir una foto (o probar con el salón de ejemplo).
     2. MEDIR     — dos líneas con sus medidas: el ancho del mueble (↔) y una
                    altura (↕: hasta el techo, el alto del mueble u otra).
                    Mientras tanto Ebora ya está mirando la foto: si ve el
                    sofá, lleva la ↔ a su sitio y propone la medida ella sola;
                    si se ve el techo, la ↕ sube hasta él.
     3. PROPUESTA — las obras que elige Ebora, colgadas de verdad: se cambian
                    de obra y de talla, se mueven, se comparan, se guardan y
                    se añaden a la cesta.

   Quién hace qué:
     · cs-salon-motor.js dibuja (perspectiva, luz, sombra). Aquí no se toca
       un píxel: solo se le dice qué obra, qué talla y dónde.
     · El worker de Ebora (/salon) decide qué obras y describe el salón.
     · /products/<handle>?view=salon da la obra LIMPIA y las tallas reales.

   Si la IA no está (sin URL, caída, sin saldo), se eligen obras por el color
   del salón medido aquí mismo. La página nunca se queda sin propuesta.
*/
(function () {
  'use strict';

  var raiz = document.querySelector('[data-cs-salon]');
  if (!raiz) return;

  function $(s) { return raiz.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(raiz.querySelectorAll(s)); }

  var T = {};
  try { T = JSON.parse($('[data-cs-salon-textos]').textContent); } catch (e) { /* textos por defecto abajo */ }

  var el = {
    portada: $('[data-cs-salon-portada]'),
    estudio: $('[data-cs-salon-estudio]'),
    zona: $('[data-cs-salon-zona]'),
    archivo: $('[data-cs-salon-archivo]'),
    ejemplo: $('[data-cs-salon-ejemplo]'),
    caja: $('[data-cs-salon-caja]'),
    lienzo: $('[data-cs-salon-lienzo]'),
    regla: $('[data-cs-salon-regla]'),
    cota: $('[data-cs-salon-cota]'),
    cotaAlto: $('[data-cs-salon-cota-alto]'),
    fantasma: $('[data-cs-salon-fantasma]'),
    fantasmaT: $('[data-cs-salon-fantasma-t]'),
    lupa: $('[data-cs-salon-lupa]'),
    anchoTitulo: $('[data-cs-salon-ancho-titulo]'),
    anchoValor: $('[data-cs-salon-ancho-valor]'),
    anchoAyuda: $('[data-cs-salon-ancho-ayuda]'),
    altoTitulo: $('[data-cs-salon-alto-titulo]'),
    altoValor: $('[data-cs-salon-alto-valor]'),
    altoAyuda: $('[data-cs-salon-alto-ayuda]'),
    altoTipos: $('[data-cs-salon-alto-tipos]'),
    altoMedidas: $('[data-cs-salon-alto-medidas]'),
    altoOtra: $('[data-cs-salon-alto-otra]'),
    muestras: $('[data-cs-salon-muestras]'),
    escaner: $('[data-cs-salon-escaner]'),
    guia: $('[data-cs-salon-guia]'),
    etiqueta: $('[data-cs-salon-etiqueta]'),
    marco: $('[data-cs-salon-marco]'),
    mano: $('[data-cs-salon-mano]'),
    manoT: $('[data-cs-salon-mano-t]'),
    recolocar: $('[data-cs-salon-recolocar]'),
    comparar: $('[data-cs-salon-comparar]'),
    otra: $('[data-cs-salon-otra]'),
    pasoMedir: $('[data-cs-salon-paso="medir"]'),
    pasoProp: $('[data-cs-salon-paso="propuesta"]'),
    medidas: $('[data-cs-salon-medidas]'),
    cmOtra: $('[data-cs-salon-cm-otra]'),
    estado: $('[data-cs-salon-estado]'),
    estadoT: $('[data-cs-salon-estado-t]'),
    colgar: $('[data-cs-salon-colgar]'),
    sinMueble: $('[data-cs-salon-sin-mueble]'),
    frase: $('[data-cs-salon-frase]'),
    lectura: $('[data-cs-salon-lectura]'),
    estilo: $('[data-cs-salon-estilo]'),
    paleta: $('[data-cs-salon-paleta]'),
    ref: $('[data-cs-salon-ref]'),
    titulo: $('[data-cs-salon-titulo]'),
    motivo: $('[data-cs-salon-motivo]'),
    tallas: $('[data-cs-salon-tallas]'),
    precio: $('[data-cs-salon-precio]'),
    cesta: $('[data-cs-salon-cesta]'),
    cestaT: $('[data-cs-salon-cesta-t]'),
    ficha: $('[data-cs-salon-ficha]'),
    carril: $('[data-cs-salon-carril]'),
    deseo: $('[data-cs-salon-deseo]'),
    deseoT: $('[data-cs-salon-deseo-t]'),
    remedir: $('[data-cs-salon-remedir]'),
    guardar: $('[data-cs-salon-guardar]'),
    cuadri: $('[data-cs-salon-cuadri]'),
    pista: $('[data-cs-salon-pista]'),
    alinear: $('[data-cs-salon-alinear]'),
    alinearListo: $('[data-cs-salon-alinear-listo]'),
    auto: $('[data-cs-salon-auto]'),
    frente: $('[data-cs-salon-frente]'),
    perspT: $('[data-cs-salon-persp-t]'),
    escena: $('[data-cs-salon-escena]'),
    barra: $('[data-cs-salon-barra]'),
    panel: $('[data-cs-salon-panel]'),
    afinar: $('[data-cs-salon-afinar]'),
    afinarAbrir: $('[data-cs-salon-afinar-abrir]'),
    afinarListo: $('[data-cs-salon-afinar-listo]'),
    hojaMedir: $('[data-cs-salon-hoja-medir]'),
    hojaTalla: $('[data-cs-salon-hoja-talla]'),
    hojaPrecio: $('[data-cs-salon-hoja-precio]'),
    herramientas: $$('[data-cs-salon-herramienta]'),
    plantilla: $('[data-cs-salon-tarjeta]'),
    tengo: $('[data-cs-salon-tengo]'),
    tengoT: $('[data-cs-salon-tengo-t]'),
    cuenta: $('[data-cs-salon-cuenta]'),
    fav: $('[data-cs-salon-fav]'),
    casa: $('[data-cs-salon-casa]'),
    estancias: $('[data-cs-salon-estancias]'),
    guardarCasa: $('[data-cs-salon-guardar-casa]'),
    guardarCasaT: $('[data-cs-salon-guardar-casa-t]'),
    guardarOtra: $('[data-cs-salon-guardar-otra]'),
    casaOk: $('[data-cs-salon-casa-ok]'),
    correo: $('[data-cs-salon-correo]'),
    correoIn: $('[data-cs-salon-correo-in]'),
    correoB: $('[data-cs-salon-correo-b]'),
    ofertas: $('[data-cs-salon-ofertas]'),
    correoEstado: $('[data-cs-salon-correo-estado]'),
    correoAbrir: $('[data-cs-salon-correo-abrir]'),
    ventana: $('[data-cs-salon-ventana]'),
    ventanaPedir: $('[data-cs-salon-ventana-pedir]'),
    ventanaHecho: $('[data-cs-salon-ventana-hecho]'),
    ventanaHechoT: $('[data-cs-salon-ventana-hecho-t]'),
  };

  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var params = new URLSearchParams(window.location.search);
  /* La obra con la que se abre: la que trae la ficha que lo pinta debajo del
     3D (data-obra, desde el 24 sep 2026) o la del enlace ?obra= de la página. */
  var obraPedida = raiz.dataset.obra || params.get('obra') || '';
  var obraInicial = /^[a-z0-9-]{1,160}$/.test(obraPedida) ? obraPedida : null;

  /* En la ficha, la dirección de la página del probador (data-pagina). Si
     está, aquí solo se enseña la portada: en cuanto hay foto, se sigue en esa
     página (ver seguirEnLaPagina). */
  var paginaCompleta = raiz.dataset.pagina || '';

  /* El worker sale de la configuración del tema. La única forma de cambiarlo
     por la URL es apuntar a localhost (para probar con `wrangler dev`): nunca
     se podrá mandar la foto de un cliente a otro sitio con un enlace. */
  var worker = (raiz.dataset.worker || '').replace(/\/+$/, '');
  var forzado = params.get('salon_worker') || '';
  if (/^http:\/\/(localhost|127\.0\.0\.1):\d{2,5}$/.test(forzado)) worker = forzado;

  var moneda = raiz.dataset.moneda || 'EUR';
  var formato;
  try { formato = new Intl.NumberFormat('es-ES', { style: 'currency', currency: moneda }); } catch (e) { formato = null; }
  function euros(cent) {
    var v = cent / 100;
    return formato ? formato.format(v).replace(/,00\s/, ' ') : v.toFixed(0) + ' €';
  }

  var S = {
    fase: 'portada',
    W: 0, H: 0,
    img: null,
    fotoIA: null,
    paleta: [],
    /* Las dos medidas (ver «Las dos medidas», más abajo). */
    regla: { a: null, b: null, cm: 200, tocada: false, medida: false, ia: false, auto: false, conMueble: true },
    alto: null,
    obraFicha: null, /* la obra con la que se abrió: su talla ideal se dibuja mientras se mide */
    ia: null,        /* { promesa, datos, error } */
    obras: [],
    actual: -1,
    colgado: false,
  };

  var motor = null;
  var gsapListo = null;

  function pideGsap() {
    if (gsapListo) return gsapListo;
    gsapListo = (window.csLib && !reducir ? window.csLib.pide('gsap') : Promise.reject())
      .then(function () { return window.gsap || null; })
      .catch(function () { return null; });
    return gsapListo;
  }

  /* ================================================================ */
  /* Pequeñas utilidades                                                */
  /* ================================================================ */

  function curva(t) { return 1 - Math.pow(1 - t, 3); }

  /* Interpolación propia para el motor (números que no son del DOM). */
  function animar(ms, alPaso) {
    return new Promise(function (ok) {
      /* Con la pestaña oculta el navegador congela requestAnimationFrame: la
         animación no avanzaría y el cambio (una obra nueva, una talla) se
         quedaría a medias. Se aplica de golpe. */
      if (reducir || ms <= 0 || document.hidden) { alPaso(1); ok(); return; }
      var t0 = performance.now();
      function paso(ahora) {
        var t = Math.min(1, (ahora - t0) / ms);
        alPaso(curva(t));
        if (t < 1) requestAnimationFrame(paso); else ok();
      }
      requestAnimationFrame(paso);
    });
  }

  var pendiente = false;
  function pintar() {
    if (pendiente || !motor) return;
    pendiente = true;
    requestAnimationFrame(function () {
      pendiente = false;
      motor.render();
      colocarRotulos();
    });
  }

  function entrar(nodo) {
    nodo.hidden = false;
    pideGsap().then(function (g) {
      if (g) g.from(nodo, { y: 18, opacity: 0, duration: 0.7, ease: 'power3.out', clearProps: 'all' });
      else { nodo.classList.remove('es-entrando'); void nodo.offsetWidth; nodo.classList.add('es-entrando'); }
    });
  }

  function escribir(nodo, texto) {
    nodo.textContent = '';
    if (reducir || !texto) { nodo.textContent = texto || ''; return; }
    var i = 0;
    var id = setInterval(function () {
      i += 2;
      nodo.textContent = texto.slice(0, i);
      if (i >= texto.length) clearInterval(id);
    }, 18);
  }

  function decir(texto, listo) {
    el.estadoT.textContent = texto;
    el.estado.classList.toggle('es-listo', !!listo);
  }

  /* En el móvil las cifras, las tallas y las obras van en filas que se
     deslizan de lado (1 nov 2026): la elegida, al centro de su fila, sin
     mover la página. En el ordenador las filas no se deslizan y no hace
     nada. */
  function centrarEnFila(fila, b) {
    if (!fila || !b || fila.scrollWidth <= fila.clientWidth) return;
    var f = fila.getBoundingClientRect(), c = b.getBoundingClientRect();
    fila.scrollLeft += c.left - f.left - (f.width - c.width) / 2;
  }

  /* En el móvil, si la foto se ha quedado arriba, fuera de la pantalla,
     se vuelve a ella: lo que se acaba de elegir se ve colgado. */
  function verFoto() {
    if (!window.matchMedia || !window.matchMedia('(max-width: 989px)').matches) return;
    if (el.caja.getBoundingClientRect().top >= 0) return;
    raiz.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'start' });
  }

  function cargarImagen(src) {
    return new Promise(function (ok, mal) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () { ok(img); };
      img.onerror = function () { mal(new Error('imagen')); };
      img.src = src;
    });
  }

  function aPx(evt) {
    var r = el.lienzo.getBoundingClientRect();
    return [((evt.clientX - r.left) / r.width) * S.W, ((evt.clientY - r.top) / r.height) * S.H];
  }
  function aCss(p) {
    var r = el.lienzo.getBoundingClientRect();
    return [(p[0] / S.W) * r.width, (p[1] / S.H) * r.height];
  }

  /* ================================================================ */
  /* 1 · La foto                                                        */
  /* ================================================================ */

  el.archivo.addEventListener('change', function () {
    var f = el.archivo.files && el.archivo.files[0];
    if (f) abrir(f);
    el.archivo.value = '';
  });

  ['dragenter', 'dragover'].forEach(function (t) {
    el.zona.addEventListener(t, function (e) { e.preventDefault(); el.zona.classList.add('es-encima'); });
  });
  ['dragleave', 'drop'].forEach(function (t) {
    el.zona.addEventListener(t, function () { el.zona.classList.remove('es-encima'); });
  });
  el.zona.addEventListener('drop', function (e) {
    e.preventDefault();
    var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (f && /^image\//.test(f.type)) abrir(f);
  });

  el.ejemplo.addEventListener('click', function () { abrir(raiz.dataset.ejemplo); });

  function avisoPortada(texto) {
    el.portada.hidden = false;
    var p = el.portada.querySelector('.cs-salon__aviso');
    if (!p) {
      p = document.createElement('p');
      p.className = 'cs-salon__aviso';
      el.zona.insertAdjacentElement('afterend', p);
    }
    p.textContent = texto;
  }

  /* DE LA FICHA A LA PÁGINA DEL PROBADOR (Gabriel, 24 sep 2026). En la
     ficha, con la foto ya subida, el probador quedaba al lado de las tallas y
     la cesta de la propia ficha: dos cestas y dos tallas a la vez, y
     confundía. Ahora la ficha solo enseña la portada; al elegir foto (o la
     pared de ejemplo) se sigue en la página del probador, a página completa,
     con esa obra y esa foto ya puestas.

     La foto viaja en IndexedDB, en una base aparte de la de Mi casa: en
     sessionStorage no cabe una foto de móvil. La página la recoge y la borra
     en el acto. Si el navegador no deja guardarla, se va a la página igual y
     allí se vuelve a elegir: es un paso más, pero nada se rompe. */
  var TRASPASO = { base: 'cs-salon-traspaso', almacen: 'fotos', clave: 'foto', vida: 15 * 60 * 1000 };

  function baseTraspaso() {
    return new Promise(function (ok, mal) {
      var pet = window.indexedDB.open(TRASPASO.base, 1);
      pet.onupgradeneeded = function () { pet.result.createObjectStore(TRASPASO.almacen); };
      pet.onsuccess = function () { ok(pet.result); };
      pet.onerror = function () { mal(pet.error); };
    });
  }

  function dejarFoto(archivo) {
    return baseTraspaso().then(function (db) {
      return new Promise(function (ok, mal) {
        var tx = db.transaction(TRASPASO.almacen, 'readwrite');
        tx.objectStore(TRASPASO.almacen).put({ archivo: archivo, t: Date.now() }, TRASPASO.clave);
        tx.oncomplete = function () { db.close(); ok(); };
        tx.onerror = function () { db.close(); mal(tx.error); };
      });
    });
  }

  function recogerFoto() {
    return baseTraspaso().then(function (db) {
      return new Promise(function (ok, mal) {
        var tx = db.transaction(TRASPASO.almacen, 'readwrite');
        var almacen = tx.objectStore(TRASPASO.almacen);
        var dato = null;
        var pet = almacen.get(TRASPASO.clave);
        pet.onsuccess = function () {
          dato = pet.result || null;
          almacen.delete(TRASPASO.clave);
        };
        tx.oncomplete = function () { db.close(); ok(dato); };
        tx.onerror = function () { db.close(); mal(tx.error); };
      });
    });
  }

  function seguirEnLaPagina(fuente) {
    var destino = paginaCompleta + '?' + (obraInicial ? 'obra=' + encodeURIComponent(obraInicial) + '&' : '');
    if (typeof fuente === 'string') {
      window.location.href = destino + 'ejemplo=1';
      return;
    }
    raiz.classList.add('es-traspasando');
    dejarFoto(fuente)
      .then(function () { window.location.href = destino + 'foto=1'; })
      .catch(function () { window.location.href = destino.replace(/[?&]$/, ''); });
  }

  function abrir(fuente) {
    if (paginaCompleta) { seguirEnLaPagina(fuente); return; }
    var url = typeof fuente === 'string' ? fuente : URL.createObjectURL(fuente);
    var deEjemplo = typeof fuente === 'string';
    cargarImagen(url)
      .then(function (img) { prepararFoto(img); S.esEjemplo = deEjemplo; })
      .catch(function () { avisoPortada(T.errorFoto || 'No hemos podido abrir esa imagen.'); });
  }

  /* `restaurar`: la escena guardada en Mi casa que se está reabriendo. Con
     ella no se mide ni se pregunta a Ebora: se vuelve a dejar todo como el
     cliente lo dejó. */
  function prepararFoto(img, restaurar) {
    if (!window.CsSalonMotor) { avisoPortada(T.errorFoto); return; }
    motor = motor || window.CsSalonMotor.crear(el.lienzo);
    var info;
    try { info = motor.foto(img); } catch (e) { avisoPortada(T.errorFoto); return; }

    S.img = img;
    S.W = info.W;
    S.H = info.H;
    S.paleta = info.paleta;
    S.fotoIA = null;
    S.obras = [];
    S.actual = -1;
    S.colgado = false;
    S.fase = 'medir';
    S.escenaId = null;
    S.restaurar = restaurar || null;
    S.esEjemplo = false;
    S.estancia = 'salon';
    S.luzDesde = null;
    if (el.casaOk) el.casaOk.hidden = true;
    clearTimeout(temporizadorVentana);
    cerrarVentana();
    if (el.correoAbrir) el.correoAbrir.hidden = true;
    S.regla = { a: [S.W * 0.22, S.H * 0.62], b: [S.W * 0.78, S.H * 0.62], cm: 200, tocada: false, medida: false, ia: false, auto: false, conMueble: true };
    S.alto = altoNuevo();
    S.descuadre = false;

    el.portada.hidden = true;
    el.estudio.hidden = false;
    el.pasoProp.hidden = true;
    el.comparar.hidden = el.afinarAbrir.hidden = true;
    el.regla.classList.remove('es-oculta');
    el.regla.setAttribute('viewBox', '0 0 ' + S.W + ' ' + S.H);
    el.regla.setAttribute('preserveAspectRatio', 'none');
    if (el.marco) el.marco.setAttribute('viewBox', '0 0 ' + S.W + ' ' + S.H);
    S.movido = false;
    rotulo = null;
    callarMano();
    el.caja.classList.remove('es-marco', 'es-sin');
    el.sinMueble.hidden = false;
    el.colgar.firstChild.nodeValue = 'Ver cuadros en mi pared ';

    motor.pared({ yaw: 0, pitch: 0, roll: 0 });
    S.persp = { modo: 'frente' };
    pintarAncho();
    pintarAlto();
    ajustarTamano();
    aplicarMedidas();
    reiniciarAjustes();
    salirAlinear(true);
    pintar();
    entrar(el.pasoMedir);
    pideGsap().then(function (g) {
      if (g) g.from(el.caja, { opacity: 0, scale: 0.97, duration: 0.9, ease: 'power3.out', clearProps: 'all' });
    });
    raiz.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'start' });

    if (restaurar) { restaurarEscena(restaurar); return; }
    enseñarMuestras();
    lanzarIA('');
  }

  function ajustarTamano() {
    if (!S.W) return;
    if (S.quad) setTimeout(dibujarQuad, 0);
    var escritorio = window.innerWidth >= 990;
    var anchoMax = el.caja.parentElement.clientWidth - (escritorio ? 0 : 0);
    var altoMax = escritorio ? window.innerHeight - 170 : window.innerHeight * 0.72;
    /* Afinando en el móvil, la foto ocupa lo que deja la hoja de los mandos. */
    if (S.afinando && !escritorio) altoMax = huecoFoto();
    var w = Math.min(anchoMax, (altoMax * S.W) / S.H);
    el.caja.style.width = Math.max(200, Math.floor(w)) + 'px';
    dibujarRegla();
    colocarRotulos();
  }
  window.addEventListener('resize', ajustarTamano);

  /* Las muestras de color aparecen sobre la foto, donde está cada color,
     mientras Ebora mira. Salen del análisis local: instantáneas. */
  function enseñarMuestras() {
    el.muestras.innerHTML = '';
    el.muestras.classList.remove('es-fuera');
    el.escaner.hidden = false;
    S.paleta.slice(0, 5).forEach(function (c, i) {
      var d = document.createElement('i');
      d.className = 'cs-salon__muestra-c';
      d.style.background = c.hex;
      d.style.left = c.donde[0] * 100 + '%';
      d.style.top = c.donde[1] * 100 + '%';
      d.style.animationDelay = 0.35 + i * 0.22 + 's';
      el.muestras.appendChild(d);
    });
  }
  function recogerMuestras() {
    el.escaner.hidden = true;
    el.muestras.classList.add('es-fuera');
    setTimeout(function () { el.muestras.innerHTML = ''; }, 600);
  }

  el.otra.addEventListener('click', function () {
    el.estudio.hidden = true;
    el.portada.hidden = false;
    S.fase = 'portada';
    raiz.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'start' });
  });

  /* ================================================================ */
  /* 2 · Ebora                                                          */
  /* ================================================================ */

  function fotoParaIA() {
    if (S.fotoIA) return S.fotoIA;
    var lado = 1024;
    var s = Math.min(1, lado / Math.max(S.W, S.H));
    var c = document.createElement('canvas');
    c.width = Math.round(S.W * s);
    c.height = Math.round(S.H * s);
    c.getContext('2d').drawImage(S.img, 0, 0, c.width, c.height);
    S.fotoIA = { url: c.toDataURL('image/jpeg', 0.82), w: c.width, h: c.height };
    return S.fotoIA;
  }

  function lanzarIA(deseo) {
    var ia = { datos: null, error: null };
    S.ia = ia;
    if (!worker) {
      /* Sin IA: se deja un momento para que se vean las muestras de color,
         que es lo único que se ha "mirado". */
      ia.error = 'sin worker';
      ia.promesa = new Promise(function (ok) { setTimeout(ok, 1600); }).then(function () {
        if (S.ia === ia) alTerminarIA(ia);
        return null;
      });
      return ia;
    }
    decir(T.mirando || 'Ebora está mirando tu salón…');
    var f = fotoParaIA();
    var control = window.AbortController ? new AbortController() : null;
    var reloj = setTimeout(function () { if (control) control.abort(); }, 45000);
    ia.promesa = fetch(worker + '/salon', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        foto: f.url,
        ancho: f.w,
        alto: f.h,
        obra: obraInicial,
        deseo: deseo || '',
        mueble_cm: S.regla.medida ? S.regla.cm : undefined,
      }),
      signal: control ? control.signal : undefined,
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.error) throw new Error(j.error || 'ia'); return j; }); })
      .then(function (datos) { ia.datos = datos; return datos; })
      .catch(function (e) { ia.error = e.message || 'ia'; return null; })
      .then(function (d) { clearTimeout(reloj); if (S.ia === ia) alTerminarIA(ia); return d; });
    return ia;
  }

  function alTerminarIA(ia) {
    if (S.colgado) return;
    recogerMuestras();
    var d = ia.datos;
    if (d && d.luz_desde && motor) { motor.luzPrevia(d.luz_desde); S.luzDesde = d.luz_desde; }
    if (d && d.estancia) S.estancia = d.estancia;
    /* Si el cliente ya ha dicho que no hay mueble, su ↔ mide otra cosa:
       lo que Ebora vea del mueble no la toca. */
    var mueble = d && d.mueble && S.regla.conMueble ? d.mueble : null;
    if (mueble && !S.regla.medida) {
      /* Su estimación entra como medida, pero floja: en cuanto el cliente
         da un número (de ancho o de alto), manda el suyo. */
      S.regla.cm = mueble.ancho_cm;
      S.regla.ia = true;
    }
    if (mueble && !S.regla.tocada) {
      var c = mueble.caja;
      var y = c[1] * S.H;
      var destinoA = [c[0] * S.W, y], destinoB = [c[2] * S.W, y];
      var origenA = S.regla.a.slice(), origenB = S.regla.b.slice();
      S.regla.auto = true;
      animar(800, function (t) {
        S.regla.a = [origenA[0] + (destinoA[0] - origenA[0]) * t, origenA[1] + (destinoA[1] - origenA[1]) * t];
        S.regla.b = [origenB[0] + (destinoB[0] - origenB[0]) * t, origenB[1] + (destinoB[1] - origenB[1]) * t];
        aplicarMedidas();
      }).then(function () { if (S.fase === 'medir' && !S.colgado) decir(consejo(d), true); });
      return;
    }
    aplicarMedidas();
    decir(consejo(d), true);
  }

  /* Lo que dice Ebora al terminar de mirar: qué ha visto y qué falta por
     marcar. Con «tu» delante, vale para cualquier mueble sin pelearse con
     el género ("tu sofá", "tu cama"). */
  function consejo(d) {
    var v = S.alto;
    var con = S.regla.conMueble;
    var ancho = '', alto = '';
    if (S.regla.medida) ancho = '';
    else if (!con) ancho = 'Pon la ↔ sobre algo pegado a la pared cuya medida sepas y elige cuánto mide.';
    else if (d && d.mueble) {
      var tipo = String(d.mueble.tipo || 'mueble').replace(/^(un|una|el|la)\s+/i, '');
      ancho = 'Calculo que tu ' + tipo + ' mide unos ' + d.mueble.ancho_cm + ' cm; si no, corrige la ↔.';
    } else if (d) ancho = 'No veo un mueble bajo la pared: pon la ↔ sobre algo que conozcas y dinos su medida.';
    else ancho = 'Pon la ↔ sobre el mueble de debajo y elige cuánto mide.';
    if (!v.medida) {
      alto = v.tocada ? 'Si sabes cuánto mide la ↕, márcalo.'
        : v.tipo === 'techo' && v.techo
        ? (con ? 'He subido la ↕ hasta el techo: comprueba que llega justo.' : 'He subido la ↕ hasta el techo: lleva el otro extremo al suelo.')
        : v.tipo === 'techo' ? (con ? 'Lleva la ↕ del mueble al techo.' : 'Lleva la ↕ del suelo al techo.')
        : v.tipo === 'mueble' ? 'No veo el techo: marca con la ↕ el alto del mueble.'
        : 'Marca con la ↕ una altura que conozcas.';
    }
    return (ancho + ' ' + alto).trim() || 'Listo: cuando quieras, vamos allá.';
  }

  /* ================================================================ */
  /* Las dos medidas                                                    */
  /* ================================================================ */

  /* Dos líneas sobre la foto, cada una con su medida (Gabriel, 25 sep 2026:
     «poder coger dos medidas de referencia y que se haga bien la estimación
     del tamaño y la recomendación del cuadro»):
       ↔ S.regla — el ancho del mueble de debajo (o de algo pegado a la
         pared, si no hay mueble). Ebora la lleva al mueble si lo ve.
       ↕ S.alto  — una altura: del mueble al techo (sin mueble, del suelo al
         techo), el alto del mueble o cualquier otra que el cliente sepa.
     Cada una, sola, basta para saber a qué distancia está la pared. Con las
     dos, el motor hace la media pesando más la más fiable, y si no cuadran
     entre sí Ebora lo dice: casi siempre es una línea mal puesta o un número
     a ojo. La que el cliente no ha dado se calcula con la otra y se enseña
     con «≈»: así se comprueba de un vistazo («¿160 del sofá al techo? Sí»).
     La ↕ sirve además para la talla: dice cuánto alto queda para el cuadro. */

  var TECHO = 250; /* la altura de un piso normal, cuando no se ha medido (cm) */
  var OJOS = 150;  /* sin mueble, el centro del cuadro va a la altura de los ojos */

  /* Lo que se puede medir en vertical. Cada texto va en pareja: con mueble
     y sin él (si solo hay uno, vale para los dos). */
  var TIPOS_ALTO = {
    techo: {
      titulo: ['Del mueble al techo', 'Del suelo al techo'],
      ayuda: [
        'Lleva la línea ↕ desde el mueble hasta el techo. Si no sabes cuánto es, déjala ahí: lo calculamos.',
        'Lleva la línea ↕ del suelo al techo. En casi todas las casas son unos 250 cm.',
      ],
      donde: ['desde el mueble hasta el techo', 'del suelo al techo'],
      cifras: [[120, 140, 150, 160, 170, 180, 200], [240, 250, 260, 270, 280, 300]],
    },
    mueble: {
      titulo: ['Alto del mueble'],
      ayuda: ['Del suelo al borde de arriba del mueble. Un sofá suele medir entre 75 y 90 cm; un aparador, unos 80.'],
      donde: ['del suelo al borde de arriba del mueble'],
      cifras: [[45, 60, 75, 80, 85, 90, 100, 120]],
    },
    otra: {
      titulo: ['Una altura que conozcas'],
      ayuda: ['Algo vertical pegado a esa pared: una puerta (203 cm), una ventana, un radiador…'],
      donde: ['a los dos extremos de lo que has medido'],
      cifras: [[60, 80, 100, 120, 150, 203, 250]],
    },
  };

  function de(lista) { return lista[Math.min(S.regla.conMueble ? 0 : 1, lista.length - 1)]; }

  function altoNuevo() {
    return { a: null, b: null, cm: null, tocada: false, medida: false, auto: false, techo: false, tipo: 'techo', tipoAuto: true };
  }

  function redondo(x) { return Math.round(x / 5) * 5; }
  function largoCm(m) { return motor && m && m.a && m.b ? motor.cmEntre(m.a, m.b) : null; }

  /* Dónde va la ↕ mientras el cliente no la toca: cerca del extremo derecho
     de la ↔, lejos del centro, que es donde irá el cuadro (y su silueta
     mientras se mide). Si se ve el techo, sube hasta él; si no, mide el alto
     del mueble. Sin mueble, del suelo al techo, a un lado de la foto. */
  function colocarAlto() {
    var v = S.alto, r = S.regla;
    if (!v || v.tocada || !r.a) return;
    var con = r.conMueble;
    var der = r.a[0] >= r.b[0] ? r.a : r.b, izq = der === r.a ? r.b : r.a;
    var pie = con
      ? [izq[0] + (der[0] - izq[0]) * 0.9, izq[1] + (der[1] - izq[1]) * 0.9]
      : [S.W * 0.9, S.H * 0.95];
    var techo = null;
    if (motor && (v.tipoAuto || v.tipo === 'techo')) {
      try { techo = motor.detectarTecho(pie[0], con ? pie[1] - S.H * 0.2 : S.H * 0.5); } catch (e) { techo = null; }
    }
    if (v.tipoAuto) {
      var tipo = techo != null || !con ? 'techo' : 'mueble';
      if (tipo !== v.tipo) {
        v.tipo = tipo;
        v.cm = null;
        v.medida = false;
        pintarAlto();
      }
    }
    /* `techo`: el extremo de arriba está en el techo que se ve. `auto`: la
       línea ya mide lo que dice su título y cuenta sin que la toquen. Con
       mueble, las dos cosas van juntas (el pie está en la ↔); sin mueble,
       el pie es una suposición hasta que el cliente lo lleva al suelo. */
    v.auto = false;
    v.techo = false;
    if (v.tipo === 'techo') {
      v.a = [pie[0], techo != null ? techo : S.H * 0.04];
      v.b = pie;
      v.techo = techo != null;
      v.auto = v.techo && con;
    } else if (v.tipo === 'mueble') {
      v.a = pie;
      v.b = [pie[0], Math.min(S.H * 0.99, pie[1] + S.H * 0.22)];
    } else {
      v.a = [S.W * 0.9, S.H * 0.28];
      v.b = [S.W * 0.9, S.H * 0.68];
    }
  }

  /* La ↕ solo cuenta como medida cuando ya está en su sitio: con el número
     puesto y la línea aún donde la dejamos, mediría otra cosa. */
  function altoColocado() {
    var v = S.alto;
    return !!(v && v.a && (v.tocada || v.auto));
  }

  /* Hay algo en que apoyarse: un número del cliente o el cálculo de Ebora.
     Sin eso, los 200 cm de partida no son de nadie y no se enseñan. */
  function hayDato() {
    return S.regla.medida || S.regla.ia || !!(S.alto && S.alto.medida && altoColocado());
  }

  /* Lo que pesa cada medida al calibrar: la inversa de su error al
     cuadrado. Dos errores: colocar los extremos (unos 12 px de pantalla, que
     en una línea corta es mucho) y el número: el del cliente, un 3 %; el que
     calcula Ebora a ojo, un 12 %; el de partida, que no ha dicho nadie, 30. */
  function peso(m, errorCifra) {
    var px = Math.hypot(m.a[0] - m.b[0], m.a[1] - m.b[1]);
    var ancho = el.lienzo.getBoundingClientRect().width || S.W;
    var errorPx = (12 * S.W) / ancho / Math.max(px, 1);
    return 1 / (errorPx * errorPx + errorCifra * errorCifra);
  }

  function referencias() {
    var r = S.regla, v = S.alto;
    var lista = [{ a: r.a, b: r.b, cm: r.cm, peso: peso(r, r.medida ? 0.03 : r.ia ? 0.12 : 0.3) }];
    if (v && v.medida && v.cm && altoColocado()) lista.push({ a: v.a, b: v.b, cm: v.cm, peso: peso(v, 0.03) });
    return lista;
  }

  function aplicarMedidas() {
    if (!motor || !S.W || !S.regla.a) return;
    colocarAlto();
    var escalas = motor.reglas(referencias());
    /* Cuánto se apartan las dos: la escala de la ↔ entre la de la ↕. */
    S.cuadre = S.regla.medida && escalas[0] && escalas[1] ? escalas[0] / escalas[1] : null;
    dibujarRegla();
    if (S.colgado) pintar();
  }

  /* Lo que dice Ebora cuando cambia una medida: si las dos cuadran; si
     falta una, qué sale con la otra, que ya es una comprobación.
     Bien puestas, dos medidas se apartan un 3-8 % (el respaldo queda unos
     centímetros por delante de la pared, y nadie coloca un extremo al
     píxel). Más de un 12 % ya es una línea mal puesta o un número a ojo. */
  function comprobarMedidas() {
    if (S.fase !== 'medir' || !motor) return;
    var r = S.regla, v = S.alto;
    var q = S.cuadre;
    if (q != null) {
      if (Math.abs(Math.log(q)) > Math.log(1.12)) {
        S.descuadre = true;
        decir('Tus dos medidas no cuadran: con ' + Math.round(r.cm) + ' cm de ancho, la ↕ mediría unos ' + redondo(v.cm * q) +
          ' cm, no ' + Math.round(v.cm) + '. Revisa que cada línea llegue justo a sus extremos.', true);
      } else {
        decir(S.descuadre ? 'Ahora sí: las dos medidas cuadran.' : 'Las dos medidas cuadran: el tamaño será fiel.', true);
        S.descuadre = false;
      }
      return;
    }
    if (v.medida && !altoColocado()) {
      decir('Ahora lleva la línea ↕ ' + de(TIPOS_ALTO[v.tipo].donde) + ': en cuanto la sueltes, cuenta.', true);
      return;
    }
    if (v.medida && !r.medida) {
      var c = largoCm(r);
      if (c) decir('Con esa altura, ' + (r.conMueble ? 'tu mueble' : 'la ↔') + ' mide unos ' + redondo(c) + ' cm. Si sabes el ancho, márcalo y lo afino.', true);
      return;
    }
    if (r.medida && !v.medida) {
      var h = altoColocado() ? largoCm(v) : null;
      decir(h
        ? 'Con ese ancho, la ↕ mide unos ' + redondo(h) + ' cm. Si sabes la altura, márcala y el tamaño saldrá aún más fiel.'
        : 'Bien. Marca también una altura con la ↕ y el tamaño saldrá aún más fiel.', true);
    }
  }

  /* ---------- El dibujo ---------- */

  var lineas = {};
  ['ancho', 'alto'].forEach(function (n) {
    var g = el.regla.querySelector('[data-linea="' + n + '"]');
    if (!g) return;
    lineas[n] = {
      g: g,
      sombra: g.querySelector('[data-r="sombra"]'),
      linea: g.querySelector('[data-r="linea"]'),
      cuerpo: g.querySelector('[data-r="cuerpo"]'),
      asas: g.querySelectorAll('.cs-salon__regla-asa'),
      toques: g.querySelectorAll('circle.cs-salon__regla-toque'),
    };
  });

  function trazar(n, m, k) {
    var L = lineas[n];
    if (!L) return;
    var ver = !!(m && m.a && m.b);
    L.g.style.display = ver ? '' : 'none';
    if (!ver) return;
    [L.sombra, L.linea, L.cuerpo].forEach(function (l) {
      l.setAttribute('x1', m.a[0]); l.setAttribute('y1', m.a[1]);
      l.setAttribute('x2', m.b[0]); l.setAttribute('y2', m.b[1]);
    });
    L.sombra.setAttribute('stroke-width', 6 * k);
    L.linea.setAttribute('stroke-width', 3 * k);
    L.linea.style.strokeDasharray = 6 * k + ' ' + 5 * k;
    L.cuerpo.setAttribute('stroke-width', 26 * k);
    [m.a, m.b].forEach(function (p, i) {
      L.asas[i].setAttribute('cx', p[0]);
      L.asas[i].setAttribute('cy', p[1]);
      L.asas[i].setAttribute('r', 11 * k);
      L.asas[i].setAttribute('stroke-width', 3 * k);
      L.toques[i].setAttribute('cx', p[0]);
      L.toques[i].setAttribute('cy', p[1]);
      L.toques[i].setAttribute('r', 24 * k);
    });
  }

  function textoMedida(m) {
    if (m.medida && m.cm) return Math.round(m.cm) + ' cm';
    var c = hayDato() ? largoCm(m) : null;
    return c ? '≈ ' + Math.round(c) + ' cm' : '? cm';
  }

  function cota(nodo, m, signo, ancho, lateral) {
    if (!nodo) return;
    if (S.fase === 'propuesta' || !m || !m.a) { nodo.hidden = true; return; }
    var c = aCss([(m.a[0] + m.b[0]) / 2, (m.a[1] + m.b[1]) / 2]);
    nodo.hidden = false;
    nodo.style.left = c[0] + 'px';
    nodo.style.top = c[1] + 'px';
    nodo.textContent = signo + textoMedida(m);
    nodo.classList.toggle('es-calculada', !m.medida);
    if (lateral) nodo.classList.toggle('a-la-izquierda', c[0] > ancho * 0.7);
  }

  function dibujarRegla() {
    if (!S.W || !S.regla.a) return;
    var r = el.lienzo.getBoundingClientRect();
    var k = S.W / (r.width || S.W);
    trazar('ancho', S.regla, k);
    trazar('alto', S.alto, k);
    cota(el.cota, S.regla, '↔ ', r.width, false);
    cota(el.cotaAlto, S.alto, '↕ ', r.width, true);
    if (el.anchoValor) el.anchoValor.textContent = textoMedida(S.regla);
    if (el.altoValor && S.alto) el.altoValor.textContent = textoMedida(S.alto);
    pintarFantasma(k);
  }

  /* LA SILUETA DEL CUADRO IDEAL, mientras se mide: un rectángulo a trazos
     encima del mueble, a su tamaño real y donde se colgaría. Es la prueba a
     simple vista de que las medidas están bien: si al lado del sofá sale
     enorme o diminuto, alguna línea no está donde debe. Si se viene de una
     obra, es su talla ideal. */
  function pintarFantasma(k) {
    var f = el.fantasma, t = el.fantasmaT;
    if (!f) return;
    var q = null, texto = '';
    if (motor && S.fase === 'medir' && !S.colgado && hayDato()) {
      var id = tallaFantasma();
      var s = sitio(id.w, id.h);
      var c = motor.desplazarPx(s.px, s.ds, s.dt - id.h / 2);
      q = c && motor.rectanguloEnPared(c, id.w, id.h);
      texto = id.texto;
    }
    if (!q) {
      f.style.display = 'none';
      if (t) t.hidden = true;
      return;
    }
    f.style.display = '';
    f.setAttribute('points', q.map(function (p) { return p[0] + ',' + p[1]; }).join(' '));
    f.setAttribute('stroke-width', 1.5 * k);
    f.style.strokeDasharray = 8 * k + ' ' + 6 * k;
    if (t) {
      var m = aCss([(q[0][0] + q[2][0]) / 2, (q[0][1] + q[2][1]) / 2]);
      t.hidden = false;
      t.style.left = m[0] + 'px';
      t.style.top = m[1] + 'px';
      t.textContent = texto;
    }
  }

  function tallaFantasma() {
    var f = S.obraFicha;
    var t = f && f.tallas.length ? tallaIdeal(f.tallas) : null;
    if (t) return { w: t.w, h: t.h, texto: 'Talla ideal · ' + t.nombre.replace(/\s*cm$/i, '') + ' cm' };
    var e = espacio();
    var w = Math.max(30, Math.round(e.meta / 10) * 10);
    var h = Math.min(Math.round((w * 0.7) / 10) * 10, Math.max(30, Math.floor(e.altoMax / 10) * 10));
    return { w: w, h: h, texto: 'Tu cuadro ideal · unos ' + w + ' cm de ancho' };
  }

  /* ---------- Arrastrar ----------
     Se coge el extremo MÁS CERCANO al dedo, sea de la línea que sea: la ↕
     nace pegada a la ↔ y sus asas se tocan; decidir por cuál está encima
     haría imposible coger la de debajo. Lejos de los extremos, el cuerpo de
     una línea la mueve entera. */
  var tiro = null;

  function asaCercana(p) {
    var ancho = el.lienzo.getBoundingClientRect().width || S.W;
    var mejor = null, dm = (26 * S.W) / ancho;
    [S.regla, S.alto].forEach(function (m) {
      if (!m || !m.a) return;
      ['a', 'b'].forEach(function (q) {
        var d = Math.hypot(m[q][0] - p[0], m[q][1] - p[1]);
        if (d < dm) { dm = d; mejor = { m: m, q: q }; }
      });
    });
    return mejor;
  }

  el.regla.addEventListener('pointerdown', function (e) {
    var r = e.target.getAttribute && e.target.getAttribute('data-r');
    if (r !== 'a' && r !== 'b' && r !== 'cuerpo') return;
    var p = aPx(e);
    var cual = asaCercana(p);
    if (!cual) {
      var g = e.target.closest && e.target.closest('[data-linea]');
      if (!g || r !== 'cuerpo') return;
      cual = { m: g.getAttribute('data-linea') === 'alto' ? S.alto : S.regla, q: 'cuerpo' };
    }
    e.preventDefault();
    tiro = { m: cual.m, q: cual.q, p0: p, a0: cual.m.a.slice(), b0: cual.m.b.slice(), id: e.pointerId };
    cual.m.tocada = true;
    try { e.target.setPointerCapture(e.pointerId); } catch (x) { /* sin captura: sigue igual */ }
    verLupa(e);
  });

  el.regla.addEventListener('pointermove', function (e) {
    if (!tiro || e.pointerId !== tiro.id) return;
    var p = aPx(e), m = tiro.m;
    if (tiro.q === 'cuerpo') {
      /* Entera, sin salirse de la foto. */
      var a0 = tiro.a0, b0 = tiro.b0;
      var dx = Math.max(-Math.min(a0[0], b0[0]), Math.min(S.W - Math.max(a0[0], b0[0]), p[0] - tiro.p0[0]));
      var dy = Math.max(-Math.min(a0[1], b0[1]), Math.min(S.H - Math.max(a0[1], b0[1]), p[1] - tiro.p0[1]));
      m.a = [a0[0] + dx, a0[1] + dy];
      m.b = [b0[0] + dx, b0[1] + dy];
    } else {
      m[tiro.q] = [Math.max(0, Math.min(S.W, p[0])), Math.max(0, Math.min(S.H, p[1]))];
    }
    aplicarMedidas();
    verLupa(e);
  });

  function soltarLinea(e) {
    if (!tiro || e.pointerId !== tiro.id) return;
    tiro = null;
    quitarLupa();
    comprobarMedidas();
  }
  el.regla.addEventListener('pointerup', soltarLinea);
  el.regla.addEventListener('pointercancel', soltarLinea);

  /* ---------- La lupa ----------
     Al arrastrar un extremo, el dedo tapa justo el punto que se marca. Una
     lente redonda, por encima del dedo, enseña ese trozo de la foto a tres
     aumentos, con una cruz en el punto exacto: así la línea llega al canto
     del sofá o a la esquina del techo sin adivinar. */
  var COLOR_LINEA = { ancho: 'rgb(212, 162, 68)', alto: 'rgb(93, 153, 170)' };

  function verLupa(e) {
    var c = el.lupa;
    var fuente = motor && motor.fotoLienzo ? motor.fotoLienzo() : null;
    if (!c || !fuente || !tiro || tiro.q === 'cuerpo') return;
    var m = tiro.m, p = m[tiro.q], otro = m[tiro.q === 'a' ? 'b' : 'a'];
    var caja = el.caja.getBoundingClientRect();
    var foto = el.lienzo.getBoundingClientRect();
    c.hidden = false;
    var lado = c.offsetWidth || 112;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var px = Math.round(lado * dpr);
    if (c.width !== px) { c.width = px; c.height = px; }

    /* Encima del dedo; si ahí se sale de la pantalla, debajo. */
    var x = Math.max(-lado * 0.25, Math.min(caja.width - lado * 0.75, e.clientX - caja.left - lado / 2));
    var y = e.clientY - lado - 36 < 6 ? e.clientY - caja.top + 36 : e.clientY - caja.top - lado - 36;
    c.style.transform = 'translate(' + Math.round(x) + 'px, ' + Math.round(y) + 'px)';

    var g = c.getContext('2d');
    var s = (foto.width / S.W) * 3 * dpr; /* px de la lupa por px de la foto */
    var lx = px / s;
    var x0 = p[0] - lx / 2, y0 = p[1] - lx / 2;
    var a0 = Math.max(0, x0), b0 = Math.max(0, y0);
    var a1 = Math.min(S.W, x0 + lx), b1 = Math.min(S.H, y0 + lx);
    g.fillStyle = '#20243a';
    g.fillRect(0, 0, px, px);
    if (a1 > a0 && b1 > b0) {
      g.drawImage(fuente, a0, b0, a1 - a0, b1 - b0, (a0 - x0) * s, (b0 - y0) * s, (a1 - a0) * s, (b1 - b0) * s);
    }
    var mitad = px / 2;
    g.lineCap = 'round';
    g.strokeStyle = COLOR_LINEA[m === S.alto ? 'alto' : 'ancho'];
    g.lineWidth = 3 * dpr;
    g.beginPath();
    g.moveTo(mitad, mitad);
    g.lineTo(mitad + (otro[0] - p[0]) * s, mitad + (otro[1] - p[1]) * s);
    g.stroke();
    /* La cruz, blanca con borde oscuro: que se vea en pared clara y oscura. */
    [['rgba(19, 22, 42, 0.75)', 3.2], ['#fff', 1.4]].forEach(function (q) {
      g.strokeStyle = q[0];
      g.lineWidth = q[1] * dpr;
      g.beginPath();
      [[-1, 0], [1, 0], [0, -1], [0, 1]].forEach(function (d) {
        g.moveTo(mitad + d[0] * 5 * dpr, mitad + d[1] * 5 * dpr);
        g.lineTo(mitad + d[0] * 15 * dpr, mitad + d[1] * 15 * dpr);
      });
      g.stroke();
    });
  }

  function quitarLupa() { if (el.lupa) el.lupa.hidden = true; }

  /* ---------- El panel ---------- */

  function marcarCifras(caja, entrada, cm) {
    var hay = false;
    Array.prototype.forEach.call(caja.querySelectorAll('[data-cm]'), function (b) {
      var si = cm != null && Number(b.dataset.cm) === Number(cm);
      b.classList.toggle('es-elegida', si);
      b.setAttribute('aria-pressed', si ? 'true' : 'false');
      if (si) { hay = true; centrarEnFila(caja, b); }
    });
    /* Mientras se escribe en «Otra», no se le toca lo escrito. */
    if (entrada && document.activeElement !== entrada) entrada.value = !hay && cm ? Math.round(cm) : '';
  }

  function pintarAncho() {
    var con = S.regla.conMueble;
    if (el.anchoTitulo) el.anchoTitulo.textContent = con ? 'Ancho del mueble' : 'Una anchura que conozcas';
    if (el.anchoAyuda) {
      el.anchoAyuda.textContent = con
        ? 'Lleva la línea ↔ de un lado a otro del mueble de debajo: sofá, cama, aparador…'
        : 'Ponla sobre algo pegado a la pared cuya medida sepas: una puerta (unos 80 cm), una ventana, un radiador, la pared entera…';
    }
    marcarCifras(el.medidas, el.cmOtra, S.regla.medida ? S.regla.cm : null);
  }

  function pintarAlto() {
    var v = S.alto;
    if (!v || !el.altoTipos || !el.altoMedidas) return;
    var t = TIPOS_ALTO[v.tipo] || TIPOS_ALTO.techo;
    el.altoTitulo.textContent = de(t.titulo);
    el.altoAyuda.textContent = de(t.ayuda);
    Array.prototype.forEach.call(el.altoTipos.querySelectorAll('[data-tipo]'), function (b) {
      b.hidden = b.dataset.tipo === 'mueble' && !S.regla.conMueble;
      b.setAttribute('aria-checked', b.dataset.tipo === v.tipo ? 'true' : 'false');
    });
    var otra = el.altoOtra ? el.altoOtra.closest('label') : null;
    Array.prototype.forEach.call(el.altoMedidas.querySelectorAll('[data-cm]'), function (b) { b.remove(); });
    de(t.cifras).forEach(function (cm) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cs-salon__chip';
      b.dataset.cm = cm;
      b.textContent = cm;
      el.altoMedidas.insertBefore(b, otra);
    });
    marcarCifras(el.altoMedidas, el.altoOtra, v.medida ? v.cm : null);
  }

  function ponerAncho(cm) {
    S.regla.cm = cm;
    S.regla.medida = true;
    S.regla.ia = false;
    marcarCifras(el.medidas, el.cmOtra, cm);
    aplicarMedidas();
  }

  function ponerAlto(cm) {
    S.alto.cm = cm;
    S.alto.medida = true;
    S.alto.tipoAuto = false;
    marcarCifras(el.altoMedidas, el.altoOtra, cm);
    aplicarMedidas();
  }

  function trasCambiarCifra() {
    comprobarMedidas();
    if (S.colgado) reelegirTalla();
  }

  el.medidas.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cm]');
    if (!b) return;
    ponerAncho(Number(b.dataset.cm));
    trasCambiarCifra();
  });
  el.cmOtra.addEventListener('input', function () {
    var v = Number(el.cmOtra.value);
    if (v >= 30 && v <= 500) ponerAncho(v);
  });
  el.cmOtra.addEventListener('change', trasCambiarCifra);

  if (el.altoMedidas) {
    el.altoMedidas.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cm]');
      if (!b || !S.alto) return;
      ponerAlto(Number(b.dataset.cm));
      trasCambiarCifra();
    });
  }
  if (el.altoOtra) {
    el.altoOtra.addEventListener('input', function () {
      var v = Number(el.altoOtra.value);
      if (v >= 20 && v <= 600 && S.alto) ponerAlto(v);
    });
    el.altoOtra.addEventListener('change', trasCambiarCifra);
  }

  /* Cambiar lo que se mide en vertical: la línea vuelve a su sitio de
     partida para eso, y el número se olvida (el de antes era de otra cosa). */
  if (el.altoTipos) {
    el.altoTipos.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tipo]');
      var v = S.alto;
      if (!b || !v) return;
      v.tipoAuto = false;
      if (b.dataset.tipo === v.tipo) return;
      v.tipo = b.dataset.tipo;
      v.cm = null;
      v.medida = false;
      v.tocada = false;
      pintarAlto();
      aplicarMedidas();
      if (S.colgado) reelegirTalla();
    });
  }

  el.sinMueble.addEventListener('click', function () {
    S.regla.conMueble = false;
    el.sinMueble.hidden = true;
    /* La ↕ de antes medía desde el mueble: empieza de nuevo, del suelo al techo. */
    S.alto = altoNuevo();
    pintarAncho();
    pintarAlto();
    aplicarMedidas();
    decir(consejo(S.ia && S.ia.datos), true);
  });

  /* ================================================================ */
  /* 3 · Colgar                                                         */
  /* ================================================================ */

  el.colgar.addEventListener('click', function () {
    if (S.obras.length) {
      /* Venía de "volver a medir": ya hay propuesta, solo se vuelve a ella.
         Con medidas nuevas, la talla de cada obra se vuelve a calcular al
         elegirla (la de la que está colgada, ahora mismo). */
      S.obras.forEach(function (o, i) { if (i !== S.actual) o.talla = null; });
      irAPropuesta();
      reelegirTalla();
      return;
    }
    el.colgar.disabled = true;
    decir(T.eligiendo || 'Eligiendo obras para tu pared…');
    el.escaner.hidden = false;
    var ia = S.ia;
    var espera = new Promise(function (ok) { setTimeout(ok, 30000); });
    Promise.race([ia.promesa, espera])
      .then(function () { return proponer(ia.datos); })
      .then(function (ok) {
        el.colgar.disabled = false;
        el.escaner.hidden = true;
        if (!ok) decir('No he encontrado obras que se puedan colgar ahora mismo. Prueba en un momento.', true);
      });
  });

  function productoJSON(handle) {
    productoJSON.cache = productoJSON.cache || {};
    if (productoJSON.cache[handle]) return productoJSON.cache[handle];
    /* SIN cabecera `accept: application/json`: con ella Shopify se salta la
       plantilla ?view=salon y devuelve su JSON estándar de producto (sin la
       obra limpia). Pasó en la tienda real el 24 sep 2026. */
    var p = fetch('/products/' + encodeURIComponent(handle) + '?view=salon')
      .then(function (r) { if (!r.ok) throw new Error('producto'); return r.text(); })
      .then(function (t) { return JSON.parse(t); })
      .catch(function () { return null; });
    productoJSON.cache[handle] = p;
    return p;
  }

  function tallasDe(prod) {
    return (prod.variantes || [])
      .map(function (v) {
        if (/pieza/i.test(v.talla)) return null;
        var m = /^\s*(\d+(?:[.,]\d+)?)\s*[xX×]\s*(\d+(?:[.,]\d+)?)/.exec(v.talla || '');
        if (!m) return null;
        return {
          id: v.id,
          nombre: v.talla,
          w: parseFloat(m[1].replace(',', '.')),
          h: parseFloat(m[2].replace(',', '.')),
          precio: v.precio,
          disponible: v.disponible,
        };
      })
      .filter(Boolean);
  }

  /* El ancho del mueble que vale: el que ha dicho el cliente o, si no, lo
     que mide su línea con las medidas que hay (que puede venir de la ↕). */
  function anchoMueble() {
    var r = S.regla;
    if (r.medida) return r.cm;
    return largoCm(r) || r.cm;
  }

  /* Cuánto alto hay para el cuadro, en cm: con mueble, del mueble al techo;
     sin mueble, del suelo al techo. `seguro`: 0 si es el de un piso normal
     porque no se ha medido, 1 si sale de la foto, 2 si lo ha dicho el
     cliente. `medido`: la línea llega de verdad al techo de la foto. */
  function altoLibre() {
    var v = S.alto, con = S.regla.conMueble;
    var puesta = altoColocado();
    if (v && (v.medida || puesta)) {
      var l = v.medida && v.cm ? v.cm : largoCm(v);
      if (l && v.tipo === 'techo') return { cm: l, seguro: v.medida ? 2 : 1, medido: puesta };
      if (l && v.tipo === 'mueble' && con) return { cm: TECHO - l, seguro: 1, medido: false };
    }
    return { cm: con ? TECHO - 85 : TECHO, seguro: 0, medido: false };
  }

  /* Lo que cabe. El ancho, la regla del taller: sobre un mueble, entre la
     mitad y tres cuartos de su ancho; lo ideal, dos tercios. Sin mueble, lo
     que propuso Ebora (o 100). El alto, lo que deja la pared: 20 cm de aire
     sobre el mueble y otros 20 hasta el techo; sin mueble, centrado a la
     altura de los ojos y a 20 cm del techo. */
  function espacio() {
    var libre = altoLibre();
    var e;
    if (S.regla.conMueble) {
      var m = anchoMueble();
      e = { meta: m * 0.64, min: m * 0.45, max: m * 0.8, mueble: m, altoMax: libre.cm - 40 };
    } else {
      var d = S.ia && S.ia.datos;
      var a = (d && d.talla_ideal && d.talla_ideal.ancho_cm) || 100;
      e = { meta: a, min: a * 0.6, max: a * 1.4, altoMax: 2 * (libre.cm - 20 - OJOS) };
    }
    e.altoMax = Math.max(30, e.altoMax);
    e.libre = libre;
    return e;
  }

  /* La talla que mejor cumple las dos cosas. Pasarse de alto pesa el
     triple que apartarse del ancho ideal (no es cuestión de gusto: no cabe),
     y más cuanto más seguro es el alto. Es lo que evita, por ejemplo, un
     vertical de 100 x 150 sobre un sofá en un piso de 2,50: con la regla del
     ancho sola, ganaba. Con la ↕ medida y sitio de sobra, vuelve a ganar. */
  function tallaIdeal(tallas) {
    var e = espacio();
    var fuerza = [3, 4, 5][e.libre.seguro];
    var mejor = null, pm = Infinity;
    tallas.forEach(function (t) {
      var p = Math.abs(t.w - e.meta);
      if (t.w > e.max) p += (t.w - e.max) * 2;
      if (t.w < e.min) p += (e.min - t.w);
      if (t.h > e.altoMax) p += (t.h - e.altoMax) * fuerza;
      if (!t.disponible) p += 10000;
      if (p < pm) { pm = p; mejor = t; }
    });
    return mejor;
  }

  /* Por qué esa talla, en la nota de debajo de las tallas. */
  function porQue() {
    if (!S.regla.conMueble) return '';
    var e = espacio();
    var txt = ' · para un mueble de ' + Math.round(e.mueble) + ' cm';
    if (e.libre.seguro && S.alto && S.alto.tipo === 'techo') txt += ' y ' + Math.round(e.libre.cm) + ' cm hasta el techo';
    return txt;
  }

  /* Sin IA: por el color del salón. El color con más presencia que tenga
     color de verdad decide la colección; si el salón es todo neutros, se le
     propone un acento (multicolor y abstractos). */
  function coleccionesPorColor() {
    var cols = [];
    S.paleta.forEach(function (c) {
      var r = c.rgb[0] / 255, g = c.rgb[1] / 255, b = c.rgb[2] / 255;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn;
      var s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
      if (s < 0.22 || c.peso < 0.04) return;
      var h = 0;
      if (d) {
        if (mx === r) h = 60 * (((g - b) / d) % 6);
        else if (mx === g) h = 60 * ((b - r) / d + 2);
        else h = 60 * ((r - g) / d + 4);
      }
      if (h < 0) h += 360;
      var col = h < 15 || h >= 345 ? 'color-rojo' : h < 42 ? (l < 0.45 ? 'color-marron' : 'color-naranja') :
        h < 65 ? 'color-amarillo' : h < 170 ? 'color-verde' : h < 250 ? 'color-azul' : h < 290 ? 'color-malva' : 'color-magenta';
      if (cols.indexOf(col) < 0) cols.push(col);
    });
    if (!cols.length) cols = ['abstractos', 'color-multicolor'];
    return cols.slice(0, 2);
  }

  function obrasSinIA() {
    var cols = coleccionesPorColor();
    return Promise.all(cols.map(function (c) {
      return fetch('/collections/' + c + '/products.json?limit=60')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    })).then(function (res) {
      var todos = [];
      res.forEach(function (r) { (r.products || []).forEach(function (p) { if (todos.indexOf(p.handle) < 0) todos.push(p.handle); }); });
      /* Barajado estable por foto: otra foto, otra propuesta. */
      var semilla = Math.round(S.W * 7 + S.H * 13);
      todos.sort(function (a, b) {
        return ((a.length * 31 + semilla) % 17) - ((b.length * 31 + semilla) % 17) || (a < b ? -1 : 1);
      });
      return todos.slice(0, 10).map(function (h) { return { handle: h, motivo: '' }; });
    });
  }

  function proponer(datos) {
    var lista = datos && datos.obras && datos.obras.length ? Promise.resolve(datos.obras) : obrasSinIA();
    return lista
      .then(function (obras) {
        if (obraInicial && !obras.some(function (o) { return o.handle === obraInicial; })) {
          obras = [{ handle: obraInicial, motivo: 'La obra que estabas mirando.' }].concat(obras);
        }
        return Promise.all(obras.slice(0, 9).map(function (o) {
          return productoJSON(o.handle).then(function (p) {
            if (!p || !p.limpia || !p.obra) return null;
            var tallas = tallasDe(p);
            if (!tallas.some(function (t) { return t.disponible; })) return null;
            return { handle: o.handle, motivo: o.motivo || '', datos: p, tallas: tallas, talla: null, img: null };
          });
        }));
      })
      .then(function (lista) {
        var validas = lista.filter(Boolean).slice(0, 6);
        if (!validas.length) return false;
        S.obras = validas;
        pintarPropuesta(datos);
        return elegir(0, true).then(function () { return true; });
      });
  }

  function pintarPropuesta(datos) {
    var frase = datos && datos.frase ? datos.frase : T.sinIa || '';
    irAPropuesta();
    escribir(el.frase, frase);

    var pal = datos && datos.paleta && datos.paleta.length ? datos.paleta : S.paleta.slice(0, 5).map(function (c) { return { hex: c.hex, nombre: '' }; });
    el.paleta.innerHTML = '';
    pal.forEach(function (c) {
      var i = document.createElement('i');
      i.style.background = c.hex;
      if (c.nombre) i.title = c.nombre;
      el.paleta.appendChild(i);
    });
    el.estilo.textContent = datos && datos.estilo ? datos.estilo : 'Los colores de tu salón';
    el.lectura.hidden = false;

    el.carril.innerHTML = '';
    S.obras.forEach(function (o, i) {
      var n = el.plantilla.content.firstElementChild.cloneNode(true);
      n.querySelector('img').src = o.datos.miniatura || o.datos.obra;
      n.querySelector('img').alt = o.datos.titulo;
      n.querySelector('.cs-salon__tarjeta-t').textContent = o.datos.titulo;
      var desde = Math.min.apply(null, o.tallas.filter(function (t) { return t.disponible; }).map(function (t) { return t.precio; }));
      n.querySelector('.cs-salon__tarjeta-p').textContent = 'desde ' + euros(desde);
      n.dataset.i = i;
      n.addEventListener('click', function () { verFoto(); elegir(i, false); });
      el.carril.appendChild(n);
    });
    pideGsap().then(function (g) {
      if (g) g.from(el.carril.children, { y: 16, opacity: 0, duration: 0.6, stagger: 0.07, ease: 'power3.out', clearProps: 'all', delay: 0.25 });
    });
  }

  function irAPropuesta() {
    S.fase = 'propuesta';
    el.pasoMedir.hidden = true;
    el.cota.hidden = true;
    if (el.cotaAlto) el.cotaAlto.hidden = true;
    if (el.fantasmaT) el.fantasmaT.hidden = true;
    quitarLupa();
    el.regla.classList.add('es-oculta');
    el.comparar.hidden = el.afinarAbrir.hidden = false;
    entrar(el.pasoProp);
    verFoto();
  }

  el.remedir.addEventListener('click', function () {
    S.fase = 'medir';
    callarMano();
    colocarRotulos();
    el.afinarAbrir.hidden = true;
    el.pasoProp.hidden = true;
    el.regla.classList.remove('es-oculta');
    el.colgar.firstChild.nodeValue = 'Listo, volver a las obras ';
    entrar(el.pasoMedir);
    dibujarRegla();
    decir('Mueve las líneas o cambia las medidas: el cuadro se ajusta mientras lo haces.', true);
  });

  /* ================================================================ */
  /* Elegir obra y talla                                                */
  /* ================================================================ */

  var turno = 0;

  function elegir(i, primera) {
    var o = S.obras[i];
    if (!o) return Promise.resolve();
    var mio = ++turno;
    var tarjetas = el.carril.children;
    Array.prototype.forEach.call(tarjetas, function (t, k) {
      t.classList.toggle('es-actual', k === i);
      t.classList.toggle('es-cargando', k === i && !o.img);
    });
    centrarEnFila(el.carril, tarjetas[i]);

    var carga = o.img ? Promise.resolve(o.img) : cargarImagen(o.datos.obra).then(function (img) { o.img = img; return img; });

    return carga.then(function (img) {
      if (mio !== turno) return;
      Array.prototype.forEach.call(tarjetas, function (t) { t.classList.remove('es-cargando'); });
      S.actual = i;
      o.talla = o.talla || tallaIdeal(o.tallas);
      pintarFicha(o);

      if (primera || !S.colgado) return colgarPrimera(o, img);
      return cambiarObra(o, img);
    }).catch(function () {
      Array.prototype.forEach.call(tarjetas, function (t) { t.classList.remove('es-cargando'); });
      el.motivo.textContent = T.errorObra || '';
    });
  }

  /* Dónde se cuelga: un píxel de partida y cuántos cm hay desde él (ds a lo
     ancho, dt hacia abajo) hasta el centro del borde de abajo del cuadro.
     Lo usan la silueta mientras se mide y el cuadro al colgarse, así que la
     silueta está justo donde luego aparece la obra. */
  function sitio(w, h) {
    var d = S.ia && S.ia.datos;
    var r = S.regla, v = S.alto;
    var libre = altoLibre();
    if (r.conMueble) {
      var aire = aireIdeal(h);
      return {
        px: [(r.a[0] + r.b[0]) / 2, (r.a[1] + r.b[1]) / 2],
        ds: 0,
        dt: -aire,
        subir: libre.medido ? Math.max(0, libre.cm - aire - h - 15) : null,
      };
    }
    var x = d && d.hueco ? ((d.hueco[0] + d.hueco[2]) / 2) * S.W : S.W / 2;
    if (v && v.a && v.tipo === 'techo' && libre.seguro) {
      /* Del suelo al techo medido: el centro, a la altura de los ojos, sin
         arrimarse al techo. */
      var suelo = v.a[1] > v.b[1] ? v.a : v.b;
      var centro = centroIdeal(h);
      var hasta = motor.entre(suelo, [x, suelo[1]]);
      return { px: suelo, ds: hasta ? hasta[0] : 0, dt: -(centro - h / 2) };
    }
    if (d && d.hueco) return { px: [x, ((d.hueco[1] + d.hueco[3]) / 2) * S.H], ds: 0, dt: h / 2 };
    return { px: [S.W / 2, S.H * 0.42], ds: 0, dt: h / 2 };
  }

  /* La altura buena, en cm: sobre un mueble, el aire entre los dos (22 cm
     por encima del respaldo; con el techo cerca, menos, nunca menos de 10:
     el aire se reparte entre arriba y abajo). Sin mueble, la del centro
     del cuadro desde el suelo: a la de los ojos, sin arrimarse al techo.
     La usan el sitio donde Ebora lo cuelga y los imanes al moverlo. */
  function aireIdeal(h) {
    var libre = altoLibre();
    return libre.seguro ? Math.max(10, Math.min(22, (libre.cm - h) * 0.45)) : 22;
  }
  function centroIdeal(h) {
    return Math.max(h / 2 + 30, Math.min(OJOS, altoLibre().cm - 20 - h / 2));
  }

  function anclaInicial(o) {
    var t = o.talla;
    var s = sitio(t.w, t.h);
    motor.anclar(s.px);
    motor.moverCm(s.ds, s.dt);
    /* Si ahí detrás hay una tele o una estantería, sube hasta pared libre
       (sin pasar del techo, si se sabe dónde está). */
    if (S.regla.conMueble) motor.buscarHueco(s.subir);
  }

  function colgarPrimera(o, img) {
    S.colgado = true;
    marcarMovido(false);
    programarVentana();
    motor.obra(img);
    motor.tamano(o.talla.w, o.talla.h);
    if (S.restaurar) {
      /* Reabierta desde Mi casa: su perspectiva y su sitio, sin recalcular. */
      motor.anclar(S.restaurar.estado.ancla);
      S.restaurar = null;
      return animar(700, function (t) {
        motor.ajustes({ despegue: 0.5 * (1 - t) });
        pintar();
      }).then(ensenarMano);
    }
    var g = autoPerspectiva();
    anclaInicial(o);
    if (g) avisoEscena('He seguido la perspectiva de tu pared (girada ' + Math.abs(Math.round(g.yaw)) + '°).');
    var w = o.talla.w, h = o.talla.h;
    return animar(1200, function (t) {
      var s = 0.94 + 0.06 * t;
      motor.tamano(w * s, h * s);
      motor.ajustes({ despegue: 1 - t });
      pintar();
    }).then(ensenarMano);
  }

  function cambiarObra(o, img) {
    var antes = motor.medidas();
    return animar(220, function (t) {
      motor.ajustes({ despegue: 0.55 * t });
      pintar();
    }).then(function () {
      motor.obra(img);
      return animar(650, function (t) {
        motor.tamano(antes.w + (o.talla.w - antes.w) * t, antes.h + (o.talla.h - antes.h) * t);
        motor.ajustes({ despegue: 0.55 * (1 - t) });
        pintar();
      });
    }).then(function () { rotuloTalla(); });
  }

  /* Cada cambio de talla dice en la foto cuál es y cuánto cuesta. `ms`,
     más corto al estirar una esquina: ahí las tallas pasan seguidas, y
     solo cuenta la última (las animaciones de antes se callan). */
  var turnoTalla = 0;
  function cambiarTalla(t, ms) {
    var o = S.obras[S.actual];
    if (!o || !t) return;
    var antes = motor.medidas();
    var mio = ++turnoTalla;
    o.talla = t;
    pintarFicha(o);
    rotuloTalla();
    animar(ms || 450, function (k) {
      if (mio !== turnoTalla) return;
      motor.tamano(antes.w + (t.w - antes.w) * k, antes.h + (t.h - antes.h) * k);
      pintar();
    });
  }

  function reelegirTalla() {
    var o = S.obras[S.actual];
    if (!o) return;
    cambiarTalla(tallaIdeal(o.tallas));
  }

  function pintarFicha(o) {
    /* Otra obra u otra talla: el «Guardada en…» ya no es lo que se ve.
       («Mándamela por correo» se queda: manda lo que se ve al pulsar.) */
    if (el.casaOk && !el.casaOk.hidden) el.casaOk.hidden = true;
    var p = o.datos;
    el.ref.textContent = p.ref || '';
    el.titulo.textContent = p.titulo;
    el.motivo.textContent = o.motivo || '';
    var ideal = tallaIdeal(o.tallas);

    el.tallas.innerHTML = '';
    o.tallas.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cs-salon__chip';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', t === o.talla ? 'true' : 'false');
      b.textContent = t.nombre.replace(/\s*cm$/i, '');
      if (t === ideal) { b.classList.add('es-ideal'); b.title = T.ideal || ''; }
      if (!t.disponible) b.disabled = true;
      b.addEventListener('click', function () { cambiarTalla(t); });
      el.tallas.appendChild(b);
    });
    var nota = document.createElement('p');
    nota.className = 'cs-salon__nota-ideal';
    nota.textContent = (T.ideal || 'Ideal para tu pared') + ': ' + ideal.nombre + porQue();
    el.tallas.appendChild(nota);
    centrarEnFila(el.tallas, el.tallas.querySelector('[aria-checked="true"]'));

    el.precio.textContent = euros(o.talla.precio);
    if (el.hojaPrecio) el.hojaPrecio.textContent = euros(o.talla.precio);
    el.cesta.dataset.id = o.talla.id;
    el.cesta.disabled = !o.talla.disponible;
    el.cesta.classList.remove('esta-dentro');
    el.cestaT.textContent = T.anadir || 'Añadir a la cesta';
    el.ficha.href = p.url + '?variant=' + o.talla.id;

    /* El corazón es el de toda la web (favoritos.js escucha cualquier
       [data-cs-fav]); aquí solo se le dice de qué obra es y cómo pintarse. */
    el.fav.dataset.csFav = o.handle;
    var esFav = !!(window.csFavoritos && window.csFavoritos.esFavorito(o.handle));
    el.fav.classList.toggle('is-fav', esFav);
    el.fav.setAttribute('aria-pressed', esFav ? 'true' : 'false');
    pintarEstancias();
  }

  /* ================================================================ */
  /* Mover el cuadro                                                    */
  /* ================================================================ */

  /* Cómo se coloca (1 nov 2026, Gabriel: «mejorar al máximo la forma en
     que se coloca el cuadro, para facilitarle la vida al cliente»):
     - Se arrastra desde donde sea: el cuadro sigue al dedo.
     - Un toque en la pared lo lleva ahí (su centro, al toque); un toque en
       el cuadro dice su talla y su precio.
     - Las esquinas se estiran para cambiar de talla, de una en una entre
       las que hay, y mientras se ve cuál es y cuánto cuesta. Con dos
       dedos, igual (pellizco).
     - Imanes: al centro del mueble y a la altura buena sobre él (sin
       mueble, al centro del hueco y a la altura de los ojos). A menos de
       4 cm se coloca solo, con un toque del móvil, y una cota dice cuánto
       queda hasta el mueble.
     - Nunca se sale de la foto, y «Recolocar» lo devuelve al sitio que
       eligió Ebora.
     El marco con las esquinas solo se ve mientras se toca y un poco
     después: la foto se queda limpia para mirarla. Y las esquinas solo
     agarran con el marco a la vista, para que quien arrastra el cuadro
     por un borde lo mueva y no lo estire sin querer. */

  var IMAN = 4;          /* cm: más cerca, el imán lo coloca solo */
  var gesto = null;      /* { tipo: 'mover' | 'talla', … } mientras hay un dedo */
  var dedos = {};
  var pellizco = null;
  var rotulo = null;     /* lo que dice la etiqueta: { tipo: 'sitio' | 'talla', … } */
  var imanAntes = { h: false, v: false };
  var turnoSitio = 0;
  var marcoReloj = null;
  var manoReloj = null;
  var tactil = window.matchMedia ? window.matchMedia('(pointer: coarse)') : { matches: false };

  var nodosM = el.marco ? {
    cotaS: el.marco.querySelector('[data-m="cota-s"]'),
    cota: el.marco.querySelector('[data-m="cota"]'),
    sombra: el.marco.querySelector('[data-m="sombra"]'),
    borde: el.marco.querySelector('[data-m="borde"]'),
    asas: [0, 1, 2, 3].map(function (i) { return el.marco.querySelector('[data-m="' + i + '"]'); }),
  } : null;

  function medio(a, b) { return [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2]; }
  function centroDe(q) { return medio(medio(q[0], q[2]), medio(q[1], q[3])); }

  /* Un toque corto del móvil al encajar en un imán o cambiar de talla (en
     los que vibran; en el iPhone no hace nada). */
  function zumbido() {
    try { if (navigator.vibrate) navigator.vibrate(8); } catch (e) { /* sin vibración */ }
  }

  function puntoMueble() {
    if (!S.regla.conMueble || !S.regla.a) return null;
    return [(S.regla.a[0] + S.regla.b[0]) / 2, (S.regla.a[1] + S.regla.b[1]) / 2];
  }
  /* Sin mueble: el centro del hueco que vio Ebora, y el suelo si la ↕ va
     del suelo al techo. */
  function puntoHueco() {
    var d = S.ia && S.ia.datos;
    return d && d.hueco ? [((d.hueco[0] + d.hueco[2]) / 2) * S.W, ((d.hueco[1] + d.hueco[3]) / 2) * S.H] : null;
  }
  function puntoSuelo() {
    var v = S.alto;
    if (S.regla.conMueble || !v || !v.a || v.tipo !== 'techo' || !altoColocado()) return null;
    return v.a[1] > v.b[1] ? v.a : v.b;
  }

  /* Los imanes, después de cada movimiento. Deja en `rotulo` lo que se
     enseña: la altura sobre el mueble (o la del centro desde el suelo) y si
     está centrado. */
  function imanes() {
    var o = S.obras[S.actual];
    rotulo = null;
    if (!o) return;
    var h = o.talla.h;
    var m = puntoMueble(), c = m || puntoHueco(), suelo = puntoSuelo();
    var desvio = c ? motor.desvioHorizontal(c) : null;
    var centrado = desvio != null && Math.abs(desvio) < IMAN;
    if (centrado) motor.moverCm(-desvio, 0);
    var alto = null, justo = false, meta;
    if (m) {
      alto = motor.alturaSobre(m);
      meta = aireIdeal(h);
    } else if (suelo) {
      var b = motor.alturaSobre(suelo);
      alto = b == null ? null : b + h / 2;
      meta = centroIdeal(h);
    }
    if (alto != null && Math.abs(alto - meta) < IMAN) {
      motor.moverCm(0, alto - meta);
      alto = meta;
      justo = true;
    }
    if ((centrado && !imanAntes.h) || (justo && !imanAntes.v)) zumbido();
    imanAntes = { h: centrado, v: justo };
    rotulo = { tipo: 'sitio', centrado: centrado, centro: c, alto: alto, justo: justo, suelo: !m && !!suelo };
  }

  /* Que el cuadro no se salga de la foto: entero, si cabe; si no, que no se
     salga su centro. */
  function mantenerDentro() {
    var q = motor.esquinas();
    if (!q) return;
    var xs = q.map(function (p) { return p[0]; }), ys = q.map(function (p) { return p[1]; });
    var dx = encajar(Math.min.apply(null, xs), Math.max.apply(null, xs), S.W);
    var dy = encajar(Math.min.apply(null, ys), Math.max.apply(null, ys), S.H);
    if (!dx && !dy) return;
    var a = motor.anclaPx();
    motor.anclar([a[0] + dx, a[1] + dy]);
  }
  /* Cuánto mover el tramo [a, b] para que quepa en [0, L], con un margen. */
  function encajar(a, b, L) {
    var m = L * 0.01;
    if (b - a <= L - 2 * m) return a < m ? m - a : b > L - m ? L - m - b : 0;
    var c = (a + b) / 2;
    return c < L * 0.04 ? L * 0.04 - c : c > L * 0.96 ? L * 0.96 - c : 0;
  }

  /* Lleva el cuadro, deslizándose, a otro sitio (su ancla, en px). Un gesto
     nuevo lo para. */
  function deslizar(hasta, ms) {
    var desde = motor.anclaPx();
    var mio = ++turnoSitio;
    return animar(ms || 380, function (t) {
      if (mio !== turnoSitio) return;
      motor.anclar([desde[0] + (hasta[0] - desde[0]) * t, desde[1] + (hasta[1] - desde[1]) * t]);
      pintar();
    }).then(function () {
      if (mio !== turnoSitio) return;
      imanes();
      pintar();
      avivar(2400);
    });
  }

  /* Un toque en la pared: el cuadro va ahí, con su centro en el toque. */
  function llevarA(p) {
    var desde = motor.anclaPx();
    motor.anclar(p);
    motor.moverCm(0, motor.medidas().h / 2);
    mantenerDentro();
    imanes();
    var hasta = motor.anclaPx();
    motor.anclar(desde);
    marcarMovido(true);
    deslizar(hasta);
  }

  /* «Recolocar»: de vuelta al sitio que eligió Ebora al colgarlo. */
  function recolocar() {
    var o = S.obras[S.actual];
    if (!o || !S.colgado) return;
    var desde = motor.anclaPx();
    anclaInicial(o);
    var hasta = motor.anclaPx();
    motor.anclar(desde);
    marcarMovido(false);
    deslizar(hasta, 520);
  }

  function marcarMovido(si) {
    S.movido = !!si;
    actualizarRecolocar();
  }
  function actualizarRecolocar() {
    if (el.recolocar) el.recolocar.hidden = !(S.movido && S.colgado && S.fase === 'propuesta');
  }

  /* El marco (y la etiqueta), a la vista `ms` desde ahora y mientras dure
     el gesto o la mano. */
  function avivar(ms) {
    el.caja.classList.add('es-marco');
    prolongar(ms);
    colocarRotulos();
  }
  function prolongar(ms) {
    clearTimeout(marcoReloj);
    marcoReloj = setTimeout(function apagar() {
      if (gesto || pellizco || S.mano) { marcoReloj = setTimeout(apagar, 600); return; }
      el.caja.classList.remove('es-marco');
      rotulo = null;
      colocarRotulos();
    }, ms || 2600);
  }

  /* La etiqueta con la talla y el precio: «120 × 90 cm · 192 €». */
  function rotuloTalla() {
    var o = S.obras[S.actual];
    if (!o || !S.colgado || S.fase !== 'propuesta') return;
    rotulo = { tipo: 'talla', texto: o.talla.nombre.replace(/\s*[xX×]\s*/, ' × ') + ' · ' + euros(o.talla.precio) };
    avivar(2000);
  }

  /* La esquina que hay bajo el dedo (o el ratón), o -1. El radio no se come
     un cuadro pequeño: en uno de 5 cm en la pantalla, tocar el medio lo
     mueve. Con el dedo, solo con el marco a la vista; con el ratón, siempre
     (el cursor ya avisa al pasar). */
  function asaEn(e) {
    if (e.pointerType !== 'mouse' && !el.caja.classList.contains('es-marco')) return -1;
    var q = motor.esquinas();
    if (!q) return -1;
    var r = el.lienzo.getBoundingClientRect();
    var pc = q.map(function (p) { return [r.left + (p[0] / S.W) * r.width, r.top + (p[1] / S.H) * r.height]; });
    var lado = Math.min(Math.hypot(pc[1][0] - pc[0][0], pc[1][1] - pc[0][1]), Math.hypot(pc[3][0] - pc[0][0], pc[3][1] - pc[0][1]));
    var radio = Math.min(e.pointerType === 'mouse' ? 14 : 28, lado * 0.35);
    var mejor = -1;
    pc.forEach(function (c, i) {
      var d = Math.hypot(e.clientX - c[0], e.clientY - c[1]);
      if (d < radio) { radio = d; mejor = i; }
    });
    return mejor;
  }

  /* Estirando una esquina: la talla (de las que hay) cuya diagonal se
     acerca más a la que pide el dedo, con un margen para que en la frontera
     entre dos no baile. */
  function tallaHacia(diag) {
    var o = S.obras[S.actual];
    if (!o || !(diag > 0)) return;
    var err = function (t) { return Math.abs(Math.log(Math.hypot(t.w, t.h) / diag)); };
    var mejor = o.talla, em = err(o.talla) - 0.05;
    o.tallas.forEach(function (t) {
      if (t.disponible && err(t) < em) { em = err(t); mejor = t; }
    });
    if (mejor !== o.talla) { cambiarTalla(mejor, 180); zumbido(); }
  }

  el.lienzo.addEventListener('pointerdown', function (e) {
    if (!S.colgado || S.fase !== 'propuesta') return;
    callarMano();
    turnoSitio++;
    dedos[e.pointerId] = [e.clientX, e.clientY];
    try { el.lienzo.setPointerCapture(e.pointerId); } catch (err) { /* puntero que ya no está */ }
    e.preventDefault();
    var ids = Object.keys(dedos);
    if (ids.length > 1) {
      var a = dedos[ids[0]], b = dedos[ids[1]];
      pellizco = { d0: Math.hypot(a[0] - b[0], a[1] - b[1]) || 1 };
      gesto = null;
      el.lienzo.classList.remove('es-arrastre');
      avivar();
      return;
    }
    var p = aPx(e);
    var o = S.obras[S.actual];
    var i = o ? asaEn(e) : -1;
    if (i >= 0) {
      var c = centroDe(motor.esquinas());
      gesto = { tipo: 'talla', c: c, d0: Math.max(4, Math.hypot(p[0] - c[0], p[1] - c[1])), diag: Math.hypot(o.talla.w, o.talla.h) };
      rotuloTalla();
      return;
    }
    var ancla = motor.anclaPx();
    gesto = {
      tipo: 'mover', off: [ancla[0] - p[0], ancla[1] - p[1]], p: p,
      x0: e.clientX, y0: e.clientY, t0: Date.now(), dentro: motor.contiene(p), movido: false,
    };
    el.lienzo.style.cursor = '';
    el.lienzo.classList.add('es-arrastre');
    avivar();
  });

  el.lienzo.addEventListener('pointermove', function (e) {
    if (!dedos[e.pointerId]) { pasarPor(e); return; }
    dedos[e.pointerId] = [e.clientX, e.clientY];
    if (pellizco) {
      var ids = Object.keys(dedos);
      if (ids.length < 2) return;
      var a = dedos[ids[0]], b = dedos[ids[1]];
      var r = Math.hypot(a[0] - b[0], a[1] - b[1]) / pellizco.d0;
      if (r > 1.18 || r < 0.85) { pasoTalla(r > 1 ? 1 : -1); pellizco.d0 *= r; }
      return;
    }
    if (!gesto) return;
    var p = aPx(e);
    if (gesto.tipo === 'talla') {
      tallaHacia((gesto.diag * Math.hypot(p[0] - gesto.c[0], p[1] - gesto.c[1])) / gesto.d0);
      return;
    }
    /* Unos px de margen: un toque que tiembla sigue siendo un toque. */
    if (!gesto.movido && Math.hypot(e.clientX - gesto.x0, e.clientY - gesto.y0) < 6) return;
    gesto.movido = true;
    motor.anclar([p[0] + gesto.off[0], p[1] + gesto.off[1]]);
    mantenerDentro();
    imanes();
    pintar();
  });

  function soltar(e) {
    if (!dedos[e.pointerId]) return;
    delete dedos[e.pointerId];
    if (Object.keys(dedos).length < 2) pellizco = null;
    var g = gesto;
    gesto = null;
    el.lienzo.classList.remove('es-arrastre');
    if (g && g.tipo === 'mover') {
      if (g.movido) marcarMovido(true);
      else if (e.type === 'pointerup' && Date.now() - g.t0 < 500) {
        if (g.dentro) rotuloTalla();
        else llevarA(g.p);
        return;
      }
    }
    /* Más grande, junto a un borde, podía quedar cortado por la foto. */
    if (g && g.tipo === 'talla') setTimeout(function () {
      if (gesto) return;
      var antes = motor.anclaPx();
      mantenerDentro();
      var hasta = motor.anclaPx();
      motor.anclar(antes);
      if (hasta[0] !== antes[0] || hasta[1] !== antes[1]) deslizar(hasta, 260);
    }, 200);
    avivar();
  }
  el.lienzo.addEventListener('pointerup', soltar);
  el.lienzo.addEventListener('pointercancel', soltar);
  el.lienzo.addEventListener('contextmenu', function (e) {
    if (S.colgado && S.fase === 'propuesta') e.preventDefault();
  });

  /* Con ratón: el marco sale al pasar por encima del cuadro, y el cursor
     dice qué hará el clic: estirar, mover o llevarlo ahí. */
  function pasarPor(e) {
    if (e.pointerType !== 'mouse') return;
    if (!S.colgado || S.fase !== 'propuesta') { el.lienzo.style.cursor = ''; return; }
    var encima = motor.contiene(aPx(e));
    var i = asaEn(e);
    if (encima || i >= 0) {
      if (el.caja.classList.contains('es-marco')) prolongar(1600);
      else avivar(1600);
    }
    el.lienzo.style.cursor = i === 0 || i === 2 ? 'nwse-resize' : i === 1 || i === 3 ? 'nesw-resize' : encima ? '' : 'pointer';
  }

  if (el.recolocar) el.recolocar.addEventListener('click', recolocar);

  /* ---------- El dibujo: marco, cota, guía y etiqueta ---------- */

  /* En cada fotograma se lee una sola vez dónde está la foto en la
     pantalla (`v`): con el dedo encima se pinta a 60 por segundo. */
  function vista() {
    var r = el.lienzo.getBoundingClientRect();
    return {
      k: S.W / (r.width || S.W),
      css: function (p) { return [(p[0] / S.W) * r.width, (p[1] / S.H) * r.height]; },
      W: el.caja.clientWidth,
      H: el.caja.clientHeight,
    };
  }

  function dibujarMarco(q, v) {
    if (!nodosM) return;
    var pts = q.map(function (p) { return p[0] + ',' + p[1]; }).join(' ');
    nodosM.sombra.setAttribute('points', pts);
    nodosM.sombra.setAttribute('stroke-width', 3 * v.k);
    nodosM.borde.setAttribute('points', pts);
    nodosM.borde.setAttribute('stroke-width', 1.5 * v.k);
    var radio = (tactil.matches ? 7.5 : 6) * v.k;
    nodosM.asas.forEach(function (c, i) {
      c.setAttribute('cx', q[i][0]);
      c.setAttribute('cy', q[i][1]);
      c.setAttribute('r', radio);
      c.setAttribute('stroke-width', 1.5 * v.k);
    });
  }

  /* La cota del cuadro al mueble: una línea de trazos, en ocre si está a
     la altura buena. */
  function dibujarCota(a, b, justa, v) {
    [[nodosM.cotaS, 3.5], [nodosM.cota, 1.6]].forEach(function (q) {
      var l = q[0];
      l.style.display = '';
      l.setAttribute('x1', a[0]); l.setAttribute('y1', a[1]);
      l.setAttribute('x2', b[0]); l.setAttribute('y2', b[1]);
      l.setAttribute('stroke-width', q[1] * v.k);
      l.setAttribute('stroke-dasharray', 5 * v.k + ' ' + 4 * v.k);
    });
    nodosM.cota.classList.toggle('es-justa', !!justa);
  }

  /* Pone una etiqueta en `p` (px de la caja) sin que se salga por los
     lados. `lado`: a la derecha del punto (a la izquierda si no cabe); si
     no, debajo (encima, con `arriba`). */
  function ponerEtiqueta(nodo, p, lado, arriba, v) {
    var w = nodo.offsetWidth;
    var x = p[0];
    nodo.classList.toggle('es-lado', !!lado);
    nodo.classList.toggle('a-la-izquierda', !!lado && x + 12 + w > v.W);
    nodo.classList.toggle('es-arriba', !lado && !!arriba);
    if (!lado) x = Math.max(w / 2 + 6, Math.min(v.W - w / 2 - 6, x));
    nodo.style.left = x + 'px';
    nodo.style.top = p[1] + 'px';
  }

  function colocarRotulos() {
    actualizarRecolocar();
    var q = S.colgado && S.fase === 'propuesta' && motor ? motor.esquinas() : null;
    if (!q) el.caja.classList.remove('es-marco');
    var ver = !!q && el.caja.classList.contains('es-marco');
    if (nodosM) { nodosM.cota.style.display = 'none'; nodosM.cotaS.style.display = 'none'; }
    el.guia.hidden = true;
    var txt = '', donde = null, lado = false;
    var v = q ? vista() : null;
    if (q) dibujarMarco(q, v);
    var abajo = q ? v.css(medio(q[2], q[3])) : null;
    var arriba = q ? v.css(medio(q[0], q[1])) : null;
    var bajo = !!abajo && abajo[1] + 44 > v.H;
    if (ver && rotulo && rotulo.tipo === 'talla') {
      txt = rotulo.texto;
      donde = bajo ? arriba : abajo;
    } else if (ver && rotulo && rotulo.tipo === 'sitio') {
      if (rotulo.centrado && rotulo.centro) {
        el.guia.hidden = false;
        el.guia.style.left = v.css(rotulo.centro)[0] + 'px';
      }
      if (rotulo.alto != null && rotulo.alto > 0) {
        var n = Math.round(rotulo.alto);
        if (rotulo.suelo) {
          txt = 'centro a ' + n + ' cm del suelo' + (rotulo.justo ? ' · a la altura de los ojos' : '');
          donde = bajo ? arriba : abajo;
        } else {
          txt = n + ' cm' + (rotulo.justo ? ' · altura ideal' : '');
          var b = nodosM ? motor.desplazarPx(motor.anclaPx(), 0, rotulo.alto) : null;
          var a = medio(q[2], q[3]);
          if (b) {
            dibujarCota(a, b, rotulo.justo, v);
            donde = v.css(medio(a, b));
            lado = true;
          } else donde = bajo ? arriba : abajo;
        }
      }
    }
    el.etiqueta.hidden = !txt;
    if (txt) {
      el.etiqueta.textContent = txt;
      el.etiqueta.classList.toggle('es-ideal', !!(rotulo && rotulo.tipo === 'sitio' && rotulo.justo));
      ponerEtiqueta(el.etiqueta, donde, lado, !lado && bajo, v);
    }
    if (S.mano && q) {
      var c = v.css(centroDe(q));
      el.mano.style.left = c[0] + 'px';
      el.mano.style.top = c[1] + 'px';
      var manoBaja = abajo[1] + el.manoT.offsetHeight + 24 > v.H;
      ponerEtiqueta(el.manoT, manoBaja ? arriba : abajo, false, manoBaja, v);
    }
  }

  /* ---------- La mano ---------- */

  /* La primera vez que se cuelga un cuadro (una vez por visita), una mano
     enseña que se mueve con el dedo y que las esquinas se estiran. Se va
     al primer toque o a los 7 segundos. */
  function ensenarMano() {
    if (!el.mano || !S.colgado || S.fase !== 'propuesta' || S.afinando) return;
    if (leerDato('sessionStorage', 'cs-salon-mano')) return;
    apuntarDato('sessionStorage', 'cs-salon-mano', '1');
    S.mano = true;
    el.manoT.textContent = tactil.matches
      ? 'Arrástralo o toca donde lo quieras · estira una esquina para cambiar la talla'
      : 'Arrástralo o haz clic donde lo quieras · tira de una esquina para cambiar la talla';
    el.mano.hidden = el.manoT.hidden = false;
    el.caja.classList.add('es-mano');
    clearTimeout(manoReloj);
    manoReloj = setTimeout(callarMano, 7000);
    avivar(7000);
  }
  function callarMano() {
    clearTimeout(manoReloj);
    if (!S.mano) return;
    S.mano = false;
    el.mano.hidden = el.manoT.hidden = true;
    el.caja.classList.remove('es-mano');
  }

  /* ---------- Talla con el pellizco, la rueda y el teclado ---------- */

  function pasoTalla(dir) {
    var o = S.obras[S.actual];
    if (!o) return;
    var validas = o.tallas.filter(function (t) { return t.disponible; }).sort(function (a, b) { return a.w * a.h - b.w * b.h; });
    var i = validas.indexOf(o.talla);
    var n = validas[Math.max(0, Math.min(validas.length - 1, i + dir))];
    if (n && n !== o.talla) { cambiarTalla(n); zumbido(); }
  }

  var ruedaQuieta = true;
  el.lienzo.addEventListener('wheel', function (e) {
    /* Solo con Ctrl (o el pellizco del trackpad, que llega como Ctrl+rueda):
       la rueda sola tiene que seguir bajando la página. */
    if (!S.colgado || S.fase !== 'propuesta' || !(e.ctrlKey || e.metaKey)) return;
    e.preventDefault();
    if (!ruedaQuieta) return;
    ruedaQuieta = false;
    pasoTalla(e.deltaY < 0 ? 1 : -1);
    setTimeout(function () { ruedaQuieta = true; }, 260);
  }, { passive: false });

  el.lienzo.addEventListener('keydown', function (e) {
    if (!S.colgado || S.fase !== 'propuesta') return;
    var paso = e.shiftKey ? 10 : 2;
    var mov = { ArrowLeft: [-paso, 0], ArrowRight: [paso, 0], ArrowUp: [0, -paso], ArrowDown: [0, paso] }[e.key];
    if (mov) {
      e.preventDefault();
      motor.moverCm(mov[0], mov[1]);
      mantenerDentro();
      marcarMovido(true);
      pintar();
      return;
    }
    if (e.key === '+' || e.key === '=') { e.preventDefault(); pasoTalla(1); }
    if (e.key === '-') { e.preventDefault(); pasoTalla(-1); }
  });

  /* Antes / después: mientras se mantiene pulsado, la pared sin cuadro. */
  function verSin(si) {
    if (!motor) return;
    motor.ajustes({ oculta: si });
    el.caja.classList.toggle('es-sin', !!si);
    pintar();
  }
  el.comparar.addEventListener('pointerdown', function (e) { e.preventDefault(); verSin(true); });
  ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (t) {
    el.comparar.addEventListener(t, function () { verSin(false); });
  });
  el.comparar.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') verSin(true); });
  el.comparar.addEventListener('keyup', function () { verSin(false); });

  /* ================================================================ */
  /* Afinar                                                             */
  /* ================================================================ */

  /* EN EL MÓVIL, A PANTALLA COMPLETA (Gabriel, 1 nov 2026: «tienes que
     bajar mucho para poder afinar la foto y, cuando afinas, no ves cómo se
     edita»). «Afinar la foto» estaba al final del panel, unos 1.600 px por
     debajo de la foto: al mover un mando, la foto ya no se veía.

     Ahora se abre con «Afinar», en la barra de debajo de la foto (o con el
     mismo «Afinar la foto» del panel), y el estudio pasa a ocupar la
     pantalla: la foto arriba, tan grande como quepa, y abajo una hoja con
     una herramienta cada vez, como en los editores de fotos. Las
     herramientas son la talla (lo que más se toca), la perspectiva, el
     giro, la inclinación, la luz y la sombra. El cuadro se sigue pudiendo
     arrastrar por la foto.

     Los mandos son los del panel, no una copia: la caja <details> se hace
     hoja por CSS (.es-afinando). La lista de tallas sí se muda a la hoja
     mientras se afina, y al cerrar vuelve a su sitio.

     El «atrás» del móvil cierra la hoja en vez de irse de la página, que
     perdería la foto: al abrir se apunta un paso en el historial.

     En el ordenador no cambia nada: la foto ya se ve al lado del panel.
     «Afinar» solo despliega la caja y baja el panel hasta ella. */
  var movil = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };
  var casaTallas = { padre: el.tallas.parentNode, sig: el.tallas.nextSibling };

  /* Lo que mide la foto por dentro de la escena, quitando la barra. */
  function huecoFoto() {
    var cs = getComputedStyle(el.escena);
    var barra = el.barra && el.barra.offsetHeight ? el.barra.offsetHeight + (parseFloat(cs.rowGap) || 0) : 0;
    return Math.max(160, el.escena.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom) - barra);
  }

  function elegirHerramienta(h) {
    el.afinar.setAttribute('data-herramienta', h);
    el.herramientas.forEach(function (b) {
      b.setAttribute('aria-selected', b.getAttribute('data-cs-salon-herramienta') === h ? 'true' : 'false');
    });
    /* La fila de tallas se desliza de lado: la elegida, al centro, que con
       las grandes quedaba fuera de la pantalla. */
    if (h === 'tamano' && S.afinando) centrarEnFila(el.tallas, el.tallas.querySelector('[aria-checked="true"]'));
  }

  function irA(y) {
    try { window.scrollTo({ top: y, behavior: 'instant' }); } catch (e) { window.scrollTo(0, y); }
  }

  function abrirAfinar() {
    if (S.fase !== 'propuesta' || S.afinando) return;
    if (!movil.matches) {
      el.afinar.open = true;
      var p = el.panel;
      var y = el.afinar.getBoundingClientRect().top - p.getBoundingClientRect().top + p.scrollTop - 16;
      p.scrollTo({ top: y, behavior: reducir ? 'auto' : 'smooth' });
      return;
    }
    S.afinando = true;
    callarMano();
    S.afinarDesde = window.scrollY;
    /* El estudio sale del flujo de la página al fijarse: sin esto la página
       encoge y, al cerrar, no se volvería al mismo sitio. */
    raiz.style.minHeight = raiz.offsetHeight + 'px';
    el.hojaTalla.appendChild(el.tallas);
    el.afinar.open = true;
    raiz.classList.add('es-afinando');
    document.documentElement.classList.add('cs-salon-afinando');
    elegirHerramienta('tamano');
    try { window.history.pushState({ csSalonAfinar: true }, ''); S.afinarAtras = true; } catch (e) { S.afinarAtras = false; }
    ajustarTamano();
    pintar();
    try { el.afinarListo.focus({ preventScroll: true }); } catch (e) { /* sin foco */ }
  }

  /* `desdeAtras`: lo ha cerrado el «atrás» del móvil, que ya ha quitado su
     paso del historial. `luego`: lo que haya que hacer al terminar de
     cerrar (con el historial ya devuelto, que si no recoloca la página). */
  function cerrarAfinar(desdeAtras, luego) {
    if (!S.afinando) return;
    if (S.fase === 'alinear') salirAlinear(false);
    S.afinando = false;
    casaTallas.padre.insertBefore(el.tallas, casaTallas.sig);
    el.afinar.open = false;
    raiz.classList.remove('es-afinando');
    document.documentElement.classList.remove('cs-salon-afinando');
    ajustarTamano();
    pintar();
    raiz.style.minHeight = '';
    irA(S.afinarDesde);
    if (S.afinarAtras && !desdeAtras) {
      S.afinarAtras = false;
      S.trasAtras = luego || null;
      window.history.back();
      return;
    }
    S.afinarAtras = false;
    if (luego) luego();
  }

  window.addEventListener('popstate', function () {
    if (S.afinando) { cerrarAfinar(true); return; }
    if (S.trasAtras) {
      var f = S.trasAtras;
      S.trasAtras = null;
      setTimeout(f, 0);
    }
  });

  el.afinarAbrir.addEventListener('click', abrirAfinar);
  el.afinar.querySelector('summary').addEventListener('click', function (e) {
    if (!movil.matches) return;
    e.preventDefault();
    abrirAfinar();
  });
  el.afinarListo.addEventListener('click', function () { cerrarAfinar(false); });
  el.hojaMedir.addEventListener('click', function () {
    cerrarAfinar(false, function () {
      el.remedir.click();
      irA(el.estudio.getBoundingClientRect().top + window.scrollY);
    });
  });
  el.herramientas.forEach(function (b) {
    b.addEventListener('click', function () {
      elegirHerramienta(b.getAttribute('data-cs-salon-herramienta'));
      /* Las 4 esquinas son de la perspectiva: con otra herramienta, fuera. */
      if (S.fase === 'alinear') salirAlinear(false);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && S.afinando) cerrarAfinar(false);
  });
  /* Un giro de tableta que la pasa a ancho de ordenador: fuera la hoja. */
  var alCambiarAncho = function () { if (!movil.matches) cerrarAfinar(false); };
  if (movil.addEventListener) movil.addEventListener('change', alCambiarAncho);
  else if (movil.addListener) movil.addListener(alCambiarAncho);

  /* ================================================================ */
  /* Perspectiva                                                        */
  /* ================================================================ */

  /* La pared que importa es la de alrededor del hueco: encima del mueble
     medido, más lo que Ebora marcó como hueco. Las rectas de otras paredes
     (una ventana lateral, el suelo) se quedan fuera. */
  function zonaPared() {
    var a = S.regla.a, b = S.regla.b;
    var x0 = Math.min(a[0], b[0]) - S.W * 0.12, x1 = Math.max(a[0], b[0]) + S.W * 0.12;
    var y = Math.max(a[1], b[1]);
    var z = [x0, y - S.H * 0.6, x1, y + S.H * 0.18];
    var d = S.ia && S.ia.datos;
    if (d && d.hueco) {
      z[0] = Math.min(z[0], d.hueco[0] * S.W); z[1] = Math.min(z[1], d.hueco[1] * S.H);
      z[2] = Math.max(z[2], d.hueco[2] * S.W); z[3] = Math.max(z[3], d.hueco[3] * S.H);
    }
    return [Math.max(0, z[0]), Math.max(0, z[1]), Math.min(S.W, z[2]), Math.min(S.H, z[3])];
  }

  function autoPerspectiva() {
    var g = null;
    try { g = motor.detectarPerspectiva(zonaPared()); } catch (e) { g = null; }
    /* Por debajo de ~4º es ruido de la medida (en una foto de frente salen
       2-3º): mejor recto que torcido de más. */
    if (g && (Math.abs(g.yaw) > 4 || Math.abs(g.pitch) > 2.5 || Math.abs(g.roll) > 1.2)) {
      motor.pared({ yaw: g.yaw, pitch: g.pitch, roll: g.roll });
      S.persp = { modo: 'auto', g: g };
    } else {
      motor.pared({ yaw: 0, pitch: 0, roll: 0 });
      S.persp = { modo: 'frente' };
      g = null;
    }
    sincronizarPersp();
    return g;
  }

  function sincronizarPersp() {
    var e = motor.estado();
    [['yaw', e.yaw], ['pitch', e.pitch]].forEach(function (q) {
      var r = raiz.querySelector('[data-cs-salon-ajuste="' + q[0] + '"]');
      if (r) { r.value = Math.round(q[1] * 2) / 2; mostrarAjuste(r); }
    });
    el.perspT.textContent = S.persp.modo === 'frente' ? 'Perspectiva: de frente'
      : S.persp.modo === 'manual' ? 'Perspectiva: ajustada a mano'
      : 'Perspectiva: automática (pared girada ' + Math.abs(Math.round(e.yaw)) + '°)';
  }

  var avisoReloj = null;
  function avisoEscena(texto) {
    if (S.fase === 'alinear') return;
    el.pista.textContent = texto;
    el.pista.hidden = false;
    clearTimeout(avisoReloj);
    avisoReloj = setTimeout(function () { if (S.fase !== 'alinear') el.pista.hidden = true; }, 4500);
  }

  el.auto.addEventListener('click', function () {
    if (!S.colgado) return;
    var g = autoPerspectiva();
    if (!g) avisoEscena('No encuentro líneas claras en esa pared: la dejo de frente. Prueba con las 4 esquinas.');
    pintar();
  });
  el.frente.addEventListener('click', function () {
    motor.pared({ yaw: 0, pitch: 0, roll: 0 });
    S.persp = { modo: 'frente' };
    sincronizarPersp();
    pintar();
  });

  /* Ajuste con 4 esquinas: el cliente lleva un cuadrilátero a algo
     rectangular de la pared y el cuadro se endereza EN VIVO mientras arrastra. */
  var nodosQ = {
    forma: el.cuadri.querySelector('[data-q="forma"]'),
    asas: [0, 1, 2, 3].map(function (i) { return el.cuadri.querySelector('[data-q="' + i + '"]'); }),
  };
  var asaQ = -1;

  function entrarAlinear() {
    if (!S.colgado) return;
    S.fase = 'alinear';
    clearTimeout(avisoReloj);
    var ap = motor.anclaPx();
    var p = [ap[0], Math.min(S.H * 0.82, ap[1] + S.H * 0.2)];
    S.quad = motor.rectanguloEnPared(p, 110, 62) ||
      [[S.W * 0.35, S.H * 0.45], [S.W * 0.65, S.H * 0.45], [S.W * 0.65, S.H * 0.65], [S.W * 0.35, S.H * 0.65]];
    el.cuadri.setAttribute('viewBox', '0 0 ' + S.W + ' ' + S.H);
    el.cuadri.setAttribute('preserveAspectRatio', 'none');
    /* Con el atributo: un <svg> no tiene la propiedad `hidden` de los
       elementos HTML, y `el.cuadri.hidden = false` no lo quitaba. Hasta el
       1 nov 2026 los 4 puntos nunca llegaron a verse. */
    el.cuadri.removeAttribute('hidden');
    el.pista.textContent = 'Lleva cada punto a una esquina de algo rectangular de esa pared: la tele, una ventana, un marco. El cuadro se endereza mientras lo mueves.';
    el.pista.hidden = false;
    el.alinearListo.hidden = false;
    el.comparar.hidden = el.afinarAbrir.hidden = true;
    callarMano();
    colocarRotulos();
    dibujarQuad();
    if (!S.afinando) el.caja.scrollIntoView({ behavior: reducir ? 'auto' : 'smooth', block: 'center' });
  }

  function salirAlinear(silencioso) {
    el.cuadri.setAttribute('hidden', '');
    el.pista.hidden = true;
    el.alinearListo.hidden = true;
    if (silencioso) return;
    S.fase = 'propuesta';
    el.comparar.hidden = el.afinarAbrir.hidden = false;
    pintar();
  }

  function dibujarQuad() {
    if (!S.quad) return;
    var r = el.lienzo.getBoundingClientRect();
    var k = S.W / (r.width || S.W);
    nodosQ.forma.setAttribute('points', S.quad.map(function (p) { return p[0] + ',' + p[1]; }).join(' '));
    nodosQ.forma.setAttribute('stroke-width', 2 * k);
    nodosQ.asas.forEach(function (c, i) {
      c.setAttribute('cx', S.quad[i][0]);
      c.setAttribute('cy', S.quad[i][1]);
      c.setAttribute('r', 12 * k);
      c.setAttribute('stroke-width', 3 * k);
    });
  }

  el.cuadri.addEventListener('pointerdown', function (e) {
    var q = e.target.getAttribute && e.target.getAttribute('data-q');
    if (q == null || q === 'forma') return;
    e.preventDefault();
    asaQ = Number(q);
    e.target.setPointerCapture(e.pointerId);
  });
  el.cuadri.addEventListener('pointermove', function (e) {
    if (asaQ < 0) return;
    var p = aPx(e);
    S.quad[asaQ] = [Math.max(0, Math.min(S.W, p[0])), Math.max(0, Math.min(S.H, p[1]))];
    dibujarQuad();
    var g = motor.orientarCon4(S.quad);
    if (g) {
      motor.pared(g);
      S.persp = { modo: 'manual' };
      sincronizarPersp();
      pintar();
    }
  });
  ['pointerup', 'pointercancel'].forEach(function (t) {
    el.cuadri.addEventListener(t, function () { asaQ = -1; });
  });

  el.alinear.addEventListener('click', entrarAlinear);
  el.alinearListo.addEventListener('click', function () { salirAlinear(false); });

  function reiniciarAjustes() {
    $$('[data-cs-salon-ajuste]').forEach(function (r) {
      r.value = r.getAttribute('data-cs-salon-ajuste') === 'luz' || r.getAttribute('data-cs-salon-ajuste') === 'sombra' ? 1 : 0;
      mostrarAjuste(r);
    });
    motor.ajustes({ luz: 1, sombra: 1, despegue: 0, oculta: false });
  }

  function mostrarAjuste(r) {
    var k = r.getAttribute('data-cs-salon-ajuste');
    /* El tramo pintado de la barra, en la hoja del móvil: de donde está sin
       tocar (0° o 100 %) hasta el valor. Así se ve de un vistazo cuánto se
       ha movido cada cosa. */
    var min = Number(r.min), max = Number(r.max);
    var pc = function (x) { return ((x - min) / (max - min)) * 100; };
    var neutro = pc(k === 'luz' || k === 'sombra' ? 1 : 0), ahora = pc(Number(r.value));
    r.style.setProperty('--de', Math.min(neutro, ahora) + '%');
    r.style.setProperty('--a', Math.max(neutro, ahora) + '%');
    var o = raiz.querySelector('output[data-o="' + k + '"]');
    if (!o) return;
    o.textContent = k === 'luz' || k === 'sombra' ? Math.round(r.value * 100) + '%' : r.value + '°';
  }

  $$('[data-cs-salon-ajuste]').forEach(function (r) {
    r.addEventListener('input', function () {
      var k = r.getAttribute('data-cs-salon-ajuste');
      var v = Number(r.value);
      if (k === 'yaw' || k === 'pitch') {
        var o = {}; o[k] = v;
        motor.pared(o);
        S.persp = { modo: 'manual' };
        el.perspT.textContent = 'Perspectiva: ajustada a mano';
      } else {
        var a = {}; a[k] = v;
        motor.ajustes(a);
      }
      mostrarAjuste(r);
      pintar();
    });
  });

  /* ================================================================ */
  /* Pedirle algo concreto a Ebora                                      */
  /* ================================================================ */

  el.deseo.addEventListener('submit', function (e) {
    e.preventDefault();
    var texto = el.deseoT.value.trim();
    if (!texto) return;
    var boton = el.deseo.querySelector('button');
    boton.disabled = true;
    el.frase.textContent = 'Buscando «' + texto + '»…';
    var ia = lanzarIA(texto);
    ia.promesa.then(function () {
      boton.disabled = false;
      if (!ia.datos || !ia.datos.obras || !ia.datos.obras.length) {
        el.frase.textContent = worker
          ? 'No he encontrado nada convincente con eso. Prueba a decírmelo de otra forma.'
          : 'Para pedir algo concreto hace falta Ebora, y ahora mismo no está disponible.';
        return;
      }
      /* Se conserva dónde está colgado: la nueva obra entra en el mismo sitio. */
      Promise.all(ia.datos.obras.map(function (o) {
        return productoJSON(o.handle).then(function (p) {
          if (!p || !p.limpia || !p.obra) return null;
          var tallas = tallasDe(p);
          if (!tallas.some(function (t) { return t.disponible; })) return null;
          return { handle: o.handle, motivo: o.motivo || '', datos: p, tallas: tallas, talla: null, img: null };
        });
      })).then(function (lista) {
        var validas = lista.filter(Boolean).slice(0, 6);
        if (!validas.length) { el.frase.textContent = 'No he encontrado obras disponibles con eso.'; return; }
        S.obras = validas;
        pintarPropuesta(ia.datos);
        elegir(0, false);
      });
    });
  });

  /* ================================================================ */
  /* Guardar y comprar                                                  */
  /* ================================================================ */

  el.guardar.addEventListener('click', function () {
    if (!motor) return;
    var o = S.obras[S.actual];
    motor.exportar(raiz.dataset.marca || '').then(function (blob) {
      var nombre = 'mi-pared-' + (o ? o.handle : 'cuadros-splash') + '.jpg';
      var archivo = window.File ? new File([blob], nombre, { type: 'image/jpeg' }) : null;
      var tactil = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (tactil && archivo && navigator.canShare && navigator.canShare({ files: [archivo] })) {
        navigator.share({ files: [archivo], title: o ? o.datos.titulo : 'Mi pared' }).catch(function () {});
        return;
      }
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = nombre;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
    });
  });

  el.cesta.addEventListener('click', function () {
    var id = el.cesta.dataset.id;
    if (el.cesta.classList.contains('esta-dentro')) { window.location.href = '/cart'; return; }
    if (!id || el.cesta.disabled) return;
    el.cesta.disabled = true;
    el.cestaT.textContent = T.anadiendo || 'Añadiendo…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (r) { if (!r.ok) throw new Error('cesta'); return r.json(); })
      .then(function () {
        el.cesta.disabled = false;
        el.cesta.classList.add('esta-dentro');
        el.cestaT.textContent = T.anadido || 'En la cesta';
        setTimeout(function () { el.cestaT.textContent = T.verCesta || 'Ver la cesta'; }, 1400);
        contadorCesta();
        if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cs-salon', productVariantId: Number(id) }); } catch (e) { /* nada */ }
        }
      })
      .catch(function () {
        el.cesta.disabled = false;
        el.cestaT.textContent = T.errorCesta || 'No se ha podido añadir';
      });
  });

  /* Igual que asesor.js: se vuelve a pedir la sección del icono y se
     sustituye entera (con el carrito vacío Dawn ni siquiera pinta burbuja). */
  function contadorCesta() {
    fetch('/?sections=cart-icon-bubble', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) {
        if (!s || !s['cart-icon-bubble']) return;
        var destino = document.getElementById('cart-icon-bubble');
        if (!destino) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var origen = doc.querySelector('.shopify-section');
        if (origen) destino.innerHTML = origen.innerHTML;
      })
      .catch(function () {});
  }

  /* ================================================================ */
  /* Viniendo de una ficha                                              */
  /* ================================================================ */

  if (obraInicial) {
    productoJSON(obraInicial).then(function (p) {
      if (!p || !p.limpia) return;
      /* Mientras se mide, la silueta es la talla ideal de ESTA obra. */
      S.obraFicha = { titulo: p.titulo, tallas: tallasDe(p) };
      dibujarRegla();
      var x = el.portada.querySelector('.cs-salon__entradilla');
      if (x) x.textContent = 'Sube una foto de tu pared y colgamos «' + p.titulo + '» a su tamaño real, con la talla que mejor le va.';
    });
  }

  /* Para comprobar el montaje sin subir nada: ?salon_demo=1 abre el ejemplo. */
  if (params.get('salon_demo') === '1') abrir(raiz.dataset.ejemplo);

  /* ================================================================ */
  /* Mi casa                                                            */
  /* ================================================================ */

  var casa = window.csMiCasa;
  if (!casa || !casa.disponible) el.casa.hidden = true;

  function contarCasa() {
    if (!casa) return;
    casa.contar().then(function (n) {
      el.cuenta.textContent = n ? '(' + n + ')' : '';
      el.tengo.hidden = !n;
      el.tengoT.textContent = n === 1 ? 'Tienes 1 pared guardada en Mi casa' : 'Tienes ' + n + ' paredes guardadas en Mi casa';
    });
  }
  contarCasa();
  document.addEventListener('cs:mi-casa-cambio', contarCasa);

  function pintarEstancias() {
    if (!casa) return;
    el.estancias.innerHTML = '';
    casa.ESTANCIAS.forEach(function (e) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cs-salon__chip';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', e[0] === S.estancia ? 'true' : 'false');
      b.textContent = e[1];
      b.addEventListener('click', function () {
        S.estancia = e[0];
        pintarEstancias();
      });
      el.estancias.appendChild(b);
    });
    el.guardarCasaT.textContent = S.escenaId ? 'Guardar cambios' : 'Guardar esta pared';
    el.guardarOtra.hidden = !S.escenaId;
  }

  function guardarEnCasa(comoNueva) {
    var o = S.obras[S.actual];
    if (!casa || !o || !motor || !S.colgado) return;
    el.guardarCasa.disabled = true;
    motor.ajustes({ oculta: false, despegue: 0 });
    var e = motor.estado();
    Promise.all([motor.fotoBlob(), motor.exportar('', 1400)])
      .then(function (b) {
        return casa.guardar({
          id: comoNueva ? null : S.escenaId,
          estancia: S.estancia,
          foto: b[0],
          imagen: b[1],
          obra: {
            handle: o.handle,
            titulo: o.datos.titulo,
            url: o.datos.url,
            ref: o.datos.ref || '',
            obra: o.datos.obra,
            miniatura: o.datos.miniatura || '',
          },
          talla: { id: o.talla.id, nombre: o.talla.nombre, w: o.talla.w, h: o.talla.h, precio: o.talla.precio },
          estado: {
            regla: { a: S.regla.a, b: S.regla.b, cm: S.regla.cm, conMueble: S.regla.conMueble, medida: S.regla.medida, ia: S.regla.ia },
            alto: S.alto && S.alto.a ? { a: S.alto.a, b: S.alto.b, cm: S.alto.cm, medida: S.alto.medida, tipo: S.alto.tipo, puesta: altoColocado() } : null,
            pared: { yaw: e.yaw, pitch: e.pitch, roll: e.roll },
            luz: e.luz,
            sombra: e.sombra,
            ancla: motor.anclaPx(),
            luzDesde: S.luzDesde,
            persp: S.persp ? S.persp.modo : 'frente',
          },
        });
      })
      .then(function (id) {
        S.escenaId = id;
        el.guardarCasa.disabled = false;
        pintarEstancias();
        el.casaOk.hidden = false;
        el.casaOk.innerHTML = '';
        el.casaOk.appendChild(document.createTextNode('Guardada en ' + casa.nombre(S.estancia) + '. '));
        var a = document.createElement('a');
        a.href = raiz.dataset.miCasa;
        a.textContent = 'Ver Mi casa →';
        el.casaOk.appendChild(a);
        ofrecerCorreo();
        pideGsap().then(function (g) {
          if (g) g.from(el.casaOk, { y: 8, opacity: 0, duration: 0.5, ease: 'power3.out', clearProps: 'all' });
        });
      })
      .catch(function () {
        el.guardarCasa.disabled = false;
        el.casaOk.hidden = false;
        el.casaOk.textContent = 'No se ha podido guardar: este navegador no deja guardar aquí (¿modo privado?).';
      });
  }

  /* ---------- «¿Te la mandamos por correo?» ----------
     Desde el 2 oct 2026 va en una ventana en medio de la pantalla
     (Gabriel). Sale sola una vez por visita: unos segundos después de
     colgar el primer cuadro en la foto del cliente, o al guardar la pared
     en Mi casa. Luego, con «Mándamela por correo». Nunca sola con la pared
     de ejemplo (no es su casa), ni si ya nos dejó su correo desde este
     navegador. Solo si el worker dice que tiene Brevo conectado.

     Se manda lo que se ve al pulsar: la pared montada, nunca la foto
     limpia. La casilla de ofertas va desmarcada y es voluntaria; el
     porqué, en el comentario de la ventana (cs-salon-probador.liquid). */
  var VENTANA_TRAS_COLGAR = 6000;
  var temporizadorVentana = null;
  var correoListo = null;

  function correoDisponible() {
    if (!correoListo) {
      correoListo = !worker ? Promise.resolve(false) : fetch(worker + '/')
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (d) { return !!d.correo; })
        .catch(function () { return false; });
    }
    return correoListo;
  }

  function leerDato(almacen, clave) {
    try { return window[almacen].getItem(clave); } catch (e) { return null; }
  }
  function apuntarDato(almacen, clave, valor) {
    try { window[almacen].setItem(clave, valor); } catch (e) { /* sin almacén: se vuelve a ofrecer, nada más */ }
  }

  function ventanaSolaPermitida() {
    return !S.esEjemplo && !leerDato('sessionStorage', 'cs-salon-ventana') && !leerDato('localStorage', 'cs-salon-correo-dado');
  }

  function programarVentana() {
    clearTimeout(temporizadorVentana);
    if (!el.ventana || !ventanaSolaPermitida()) return;
    temporizadorVentana = setTimeout(function intento() {
      if (!S.colgado || S.fase !== 'propuesta' || !ventanaSolaPermitida()) return;
      /* Si está moviendo el cuadro, viendo la mano que enseña a moverlo,
         escribiendo o hablando con Ebora, se espera un poco más. */
      var activo = document.activeElement;
      var asesor = document.getElementById('cs-asesor-panel');
      if (gesto || S.mano || (asesor && !asesor.hidden) || (activo && raiz.contains(activo) && /^(INPUT|TEXTAREA|SELECT)$/.test(activo.tagName))) {
        temporizadorVentana = setTimeout(intento, 4000);
        return;
      }
      abrirVentana(true);
    }, VENTANA_TRAS_COLGAR);
  }

  function abrirVentana(sola) {
    if (!el.ventana || el.ventana.open) return;
    correoDisponible().then(function (si) {
      if (!si || !S.colgado || el.ventana.open) return;
      if (sola) apuntarDato('sessionStorage', 'cs-salon-ventana', '1');
      el.ventanaPedir.hidden = false;
      el.ventanaHecho.hidden = true;
      el.correoB.disabled = false;
      el.correoB.textContent = 'Mandármela';
      el.correoEstado.hidden = true;
      el.ofertas.checked = false;
      if (!el.correoIn.value) el.correoIn.value = leerDato('localStorage', 'cs-salon-correo') || '';
      if (typeof el.ventana.showModal === 'function') el.ventana.showModal();
      else el.ventana.setAttribute('open', '');
      el.correoAbrir.hidden = false;
    });
  }

  /* Idempotente, y sin colgar nada del evento `close`: en algunos
     navegadores (y en el panel de pruebas) no llega. */
  function cerrarVentana() {
    if (!el.ventana || !el.ventana.open) return;
    if (typeof el.ventana.close === 'function') el.ventana.close();
    else el.ventana.removeAttribute('open');
  }

  /* Tras guardar la pared en Mi casa. */
  function ofrecerCorreo() {
    correoDisponible().then(function (si) {
      if (!si || !el.correoAbrir) return;
      el.correoAbrir.hidden = false;
      if (ventanaSolaPermitida()) abrirVentana(true);
    });
  }

  function aBase64(blob) {
    return new Promise(function (ok, mal) {
      var r = new FileReader();
      r.onload = function () { ok(String(r.result).split(',')[1] || ''); };
      r.onerror = mal;
      r.readAsDataURL(blob);
    });
  }

  function avisoCorreo(texto, error) {
    el.correoEstado.hidden = false;
    el.correoEstado.textContent = texto;
    el.correoEstado.classList.toggle('es-error', !!error);
  }

  /* ---------- La animación del correo: antes y después ----------
     Va en el correo como GIF, que es lo único que se mueve en Gmail. Se
     hace aquí, con el mismo motor que pinta la escena, fotograma a
     fotograma, y al final se deja todo como estaba.

     Primero fue una caída con golpe y temblor («que se vea brutal»), y a
     Gabriel le pareció brusca: «tiene que ser más elegante» (2 oct 2026).
     Ahora: la pared vacía; el cuadro que aparece poco a poco, un poco
     separado de la pared, y se apoya en ella mientras la sombra se asienta;
     quieto; y se desvanece despacio antes de volver a empezar. La aparición
     es una mezcla, píxel a píxel, de la pared vacía y la pared con el
     cuadro (el GIF no tiene transparencias a medias).

     Para que pese poco: una sola paleta para toda la animación (sacada de
     la pared vacía y de la pared con el cuadro); un tramado ordenado, que
     no cambia de un fotograma a otro; y en cada fotograma solo cuentan los
     píxeles que cambian (el resto va transparente y se queda el de antes).
     Las esperas largas son un único fotograma con mucho retraso. */
  var GIF_LADO = 560;
  var GIF_AREA = 560 * 420; /* una foto cuadrada sale a 485 × 485 */
  var GIF_MAX_BYTES = 1400000;
  var BAYER = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
  var gifencListo = null;

  function pideGifenc() {
    if (window.CsGifenc) return Promise.resolve(window.CsGifenc);
    if (!gifencListo) {
      gifencListo = new Promise(function (ok, mal) {
        var s = document.createElement('script');
        s.src = raiz.dataset.gifenc;
        s.onload = function () { window.CsGifenc ? ok(window.CsGifenc) : mal(new Error('gifenc')); };
        s.onerror = function () { gifencListo = null; mal(new Error('gifenc')); };
        document.head.appendChild(s);
      });
    }
    return gifencListo;
  }

  function suave(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function frena(t) { return 1 - Math.pow(1 - t, 3); }

  function animacionColgar() {
    return pideGifenc().then(function (G) {
      var lienzo = el.lienzo;
      var k = Math.min(1, GIF_LADO / Math.max(lienzo.width, lienzo.height), Math.sqrt(GIF_AREA / (lienzo.width * lienzo.height)));
      var w = Math.round(lienzo.width * k), h = Math.round(lienzo.height * k);
      var c = document.createElement('canvas');
      c.width = w;
      c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true });
      var ancla = motor.anclaPx();
      var med = motor.medidas();

      function colocar(cmArriba, escala, despegue, oculta) {
        motor.anclar((cmArriba && motor.desplazarPx(ancla, 0, -cmArriba)) || ancla);
        motor.tamano(med.w * escala, med.h * escala);
        motor.ajustes({ despegue: despegue, oculta: !!oculta });
      }

      function captura() {
        motor.render();
        x.drawImage(lienzo, 0, 0, w, h);
        return x.getImageData(0, 0, w, h).data;
      }

      /* La mezcla de las dos capturas, ya tramada. */
      function fotograma(vacia, conCuadro, a) {
        var d = new Uint8ClampedArray(vacia.length);
        for (var py = 0, i = 0; py < h; py++) {
          for (var px = 0; px < w; px++, i += 4) {
            var t = (BAYER[((py & 3) << 2) | (px & 3)] - 7.5) * 1.1;
            d[i] = vacia[i] + (conCuadro[i] - vacia[i]) * a + t;
            d[i + 1] = vacia[i + 1] + (conCuadro[i + 1] - vacia[i + 1]) * a + t;
            d[i + 2] = vacia[i + 2] + (conCuadro[i + 2] - vacia[i + 2]) * a + t;
            d[i + 3] = 255;
          }
        }
        return d;
      }

      var fotos = [];
      try {
        /* 1 · La pared vacía, tal cual. */
        colocar(0, 1, 0, true);
        var vacia = captura();
        fotos.push({ d: fotograma(vacia, vacia, 0), espera: 1200 });

        /* 2 · Aparece: de un poco separado y más arriba, a apoyado. */
        var PASOS = 18;
        for (var n = 1; n <= PASOS; n++) {
          var u = n / PASOS;
          var f = frena(u);
          colocar(3 * (1 - f), 1 + 0.02 * (1 - f), 1 - f);
          fotos.push({ d: fotograma(vacia, captura(), suave(Math.min(1, u * 1.25))), espera: 55 });
        }

        /* 3 · Quieto, colgado. */
        colocar(0, 1, 0);
        var final = captura();
        fotos.push({ d: fotograma(vacia, final, 1), espera: 3400 });

        /* 4 · Se desvanece, y el bucle vuelve a la pared vacía. */
        var SALIDA = 8;
        for (var m = 1; m < SALIDA; m++) {
          fotos.push({ d: fotograma(vacia, final, 1 - suave(m / SALIDA)), espera: 55 });
        }
      } finally {
        motor.anclar(ancla);
        motor.tamano(med.w, med.h);
        motor.ajustes({ despegue: 0, oculta: false });
        pintar();
      }

      /* La paleta, de la pared vacía y de la pared con el cuadro. El
         hueco 0 es el color transparente: una copia del primero, y como
         applyPalette, ante un empate, se queda con el último, nunca lo
         elige para un píxel de verdad. */
      var muestra = new Uint8ClampedArray(w * h * 8);
      muestra.set(fotos[0].d, 0);
      muestra.set(fotos[PASOS + 1].d, w * h * 4);
      var paleta = G.quantize(muestra, 255);
      paleta.unshift(paleta[0].slice());

      var gif = G.GIFEncoder();
      var antes = null;
      fotos.forEach(function (f) {
        var idx = G.applyPalette(f.d, paleta);
        if (!antes) {
          gif.writeFrame(idx, w, h, { palette: paleta, delay: f.espera, repeat: 0 });
          antes = idx.slice();
          return;
        }
        for (var i = 0; i < idx.length; i++) {
          if (idx[i] === antes[i]) idx[i] = 0;
          else antes[i] = idx[i];
        }
        gif.writeFrame(idx, w, h, { delay: f.espera, transparent: true, transparentIndex: 0, dispose: 1 });
      });
      gif.finish();
      var bytes = gif.bytes();
      if (bytes.length > GIF_MAX_BYTES) return null;
      return new Blob([bytes], { type: 'image/gif' });
    });
  }

  if (el.ventana) {
    [].forEach.call(el.ventana.querySelectorAll('[data-cs-salon-ventana-cerrar]'), function (b) {
      b.addEventListener('click', cerrarVentana);
    });
    /* Pulsar en el fondo oscuro, fuera de la caja, también la cierra. */
    el.ventana.addEventListener('click', function (ev) {
      if (ev.target === el.ventana) cerrarVentana();
    });
    el.correoAbrir.addEventListener('click', function () { abrirVentana(false); });

    el.correo.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var o = S.obras[S.actual];
      var correo = el.correoIn.value.trim();
      if (!o || !motor || !S.colgado) return;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(correo)) {
        avisoCorreo('Revisa el correo: parece que falta algo.', true);
        el.correoIn.focus();
        return;
      }
      var ofertas = !!el.ofertas.checked;
      el.correoB.disabled = true;
      el.correoB.textContent = 'Preparando tu animación…';
      el.correoEstado.hidden = true;
      /* Un respiro antes de la animación (que ocupa el navegador un
         momento), para que se vea el «Preparando…». Si la animación falla,
         la imagen fija sale igual. */
      new Promise(function (ok) { setTimeout(ok, 40); })
        .then(function () { return animacionColgar().catch(function () { return null; }); })
        .then(function (gif) {
          el.correoB.textContent = 'Mandando…';
          motor.ajustes({ oculta: false, despegue: 0 });
          return Promise.all([
            Promise.resolve(motor.exportar('', 1400)).then(aBase64),
            gif ? aBase64(gif) : '',
          ]);
        })
        .then(function (b) {
          return fetch(worker + '/pared', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({
              correo: correo,
              ofertas: ofertas,
              estancia: S.estancia,
              imagen: b[0],
              animacion: b[1] || undefined,
              obra: { handle: o.handle, titulo: o.datos.titulo, url: o.datos.url },
              talla: { id: o.talla.id, nombre: o.talla.nombre, precio: o.talla.precio },
              pagina: window.location.pathname,
            }),
          });
        })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { d.status = r.status; return d; }); })
        .then(function (d) {
          if (!d.ok) throw d;
          apuntarDato('localStorage', 'cs-salon-correo', correo);
          apuntarDato('localStorage', 'cs-salon-correo-dado', '1');
          el.ventanaPedir.hidden = true;
          el.ventanaHecho.hidden = false;
          el.ventanaHechoT.textContent = ofertas
            ? 'Te llega a ' + correo + ', con tu código del 10% dentro. Si no lo ves, mira en Promociones o en el spam.'
            : 'Te llega a ' + correo + '. Si no lo ves, mira en Promociones o en el spam.';
        })
        .catch(function (d) {
          el.correoB.disabled = false;
          el.correoB.textContent = 'Mandármela';
          var e = d && d.error;
          avisoCorreo(
            e === 'correo' ? 'Revisa el correo: parece que falta algo.'
              : e === 'limite' ? 'Hoy ya te hemos mandado varias. Descárgala con «Guardar la imagen» o prueba mañana.'
              : 'No hemos podido mandarla ahora. Prueba otra vez en un momento.',
            true
          );
        });
    });
  }

  el.guardarCasa.addEventListener('click', function () { guardarEnCasa(false); });
  el.guardarOtra.addEventListener('click', function () { guardarEnCasa(true); });

  /* Reabrir una pared guardada (?pared=<id>): misma foto, medida,
     perspectiva, luz y sitio. La obra se vuelve a leer de la tienda para
     que el precio y la disponibilidad sean los de hoy. */
  function restaurarEscena(esc) {
    S.escenaId = esc.id;
    S.estancia = esc.estancia;
    S.luzDesde = esc.estado.luzDesde || null;
    /* Las paredes guardadas antes del 25 sep 2026 solo traen la ↔, y la
       daban siempre por buena: se reabren igual que entonces. */
    var rg = esc.estado.regla;
    S.regla = {
      a: rg.a, b: rg.b, cm: rg.cm,
      tocada: true, medida: rg.medida !== false, ia: !!rg.ia, auto: false, conMueble: rg.conMueble !== false,
    };
    var al = esc.estado.alto;
    S.alto = altoNuevo();
    if (al && al.a && al.b) {
      S.alto = {
        a: al.a, b: al.b, cm: al.cm || null, medida: !!al.medida, tipo: TIPOS_ALTO[al.tipo] ? al.tipo : 'techo',
        tocada: al.puesta !== false, auto: false, techo: false, tipoAuto: false,
      };
    }
    S.descuadre = false;
    pintarAncho();
    pintarAlto();
    aplicarMedidas();
    motor.pared(esc.estado.pared);
    if (S.luzDesde) motor.luzPrevia(S.luzDesde);
    S.persp = { modo: esc.estado.persp || 'manual' };
    sincronizarPersp();
    [['luz', esc.estado.luz], ['sombra', esc.estado.sombra]].forEach(function (q) {
      var r = raiz.querySelector('[data-cs-salon-ajuste="' + q[0] + '"]');
      if (r && q[1] != null) { r.value = q[1]; mostrarAjuste(r); }
    });
    motor.ajustes({ luz: esc.estado.luz || 1, sombra: esc.estado.sombra == null ? 1 : esc.estado.sombra });
    S.ia = null;
    productoJSON(esc.obra.handle).then(function (p) {
      if (!p || !p.limpia || !p.obra) {
        S.restaurar = null;
        decir('Esa obra ya no está disponible. Pulsa el botón y te propongo otras por los colores de tu casa.', true);
        S.ia = lanzarIA('');
        return;
      }
      var tallas = tallasDe(p);
      var t = tallas.filter(function (x) { return x.id === esc.talla.id; })[0] || null;
      S.obras = [{ handle: esc.obra.handle, motivo: '', datos: p, tallas: tallas, talla: t, img: null }];
      pintarPropuesta({
        frase: 'Tu pared de ' + casa.nombre(esc.estancia).toLowerCase() + ', tal como la dejaste. Cambia la talla o la posición, o pídeme otras ideas aquí abajo.',
      });
      elegir(0, true);
    });
  }

  /* Llegar desde la ficha con la foto ya elegida (?foto=1) o con la pared de
     ejemplo (?ejemplo=1). Se quitan de la dirección al recogerlas, para que
     recargar la página no intente abrir una foto que ya no está. */
  if (!paginaCompleta && (params.get('foto') === '1' || params.get('ejemplo') === '1')) {
    var conFoto = params.get('foto') === '1';
    params.delete('foto');
    params.delete('ejemplo');
    var limpia = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
    try { window.history.replaceState(window.history.state, '', limpia); } catch (e) { /* sin historial: da igual */ }

    if (!conFoto) {
      abrir(raiz.dataset.ejemplo);
    } else {
      el.portada.hidden = true; // que no asome la portada mientras llega la foto
      recogerFoto()
        .then(function (d) {
          if (d && d.archivo && Date.now() - d.t < TRASPASO.vida) abrir(d.archivo);
          else el.portada.hidden = false;
        })
        .catch(function () { el.portada.hidden = false; });
    }
  }

  var paredId = !paginaCompleta && params.get('pared');
  if (paredId && casa) {
    casa.leer(paredId).then(function (esc) {
      if (!esc || !esc.foto) return;
      cargarImagen(URL.createObjectURL(esc.foto)).then(function (img) { prepararFoto(img, esc); });
    }).catch(function () { /* se queda en la portada */ });
  }


  /* Utilidad de depuración, sin efecto en la página. */
  window.csSalon = { estado: S, motor: function () { return motor; }, abrir: abrir };
})();
